; /* START FILE common/js/uiElements.js */ window.__ignoreHashChange = 0

function installHashChangeHandler() {
    window.addEventListener('hashchange', function() {
        if (window.__ignoreHashChange === 0) {
            if (window._dialog && window._dialog.hasChangedValues()) {
                if (window._dialog.confirmLeave()) {
                    goToCurrentTabOrDefault()
                }
            } else {
                goToCurrentTabOrDefault()
            }

        }
    })

    $(window).bind('beforeunload', function(e) {
        if (window._dialog && window._dialog.hasChangedValues()) {
            return true
        }
    })
}

window.__preventHashChange = false

// Use this instead of all location.reload()s if you want the current
// location.hash to be reloaded. (It's possible to change it after
// location.reload() call and it unfortunately affects the outcome.
// Assumes that all location hash changes are done with
// setLocationHashStealthily().
function reloadWithThisHash() {
    window.__preventHashChange = true
    window.location.reload()
}

// Sets location.hash without triggering the hashchange handler.
// (The hashchange handler checks the value if __ignoreHashChange)
// If a window reload has been triggered by calling reloadWithThisHash(),
// don't do anything.
function setLocationHashStealthily(tabName, args) {
    if (window.__preventHashChange) {
        return
    }

    window.__ignoreHashChange++
    if (args) {
        location.hash = tabName + '-' + encodeURIComponent(JSON.stringify(args))
    } else {
        location.hash = tabName
    }

    setTimeout(function() {
        window.__ignoreHashChange--
    }, 1)
}

window.__currentTabArgs = null

// Parse current location.hash to get routing info.
// Return {
//     hash: 'users-%5B123%2C%7B"x"%3A"y-z"%7D%5D' // the whole hash, encoded
//     tabName: 'users', // name of tab
//     tabArgs: [1234, { x: 'y-z' }] // argument to current page, any JSON works
// }
function getTabNameAndArgsFromCurrentHash() {
    var hash = window.location.hash.slice(1)

    // Support for old-style /#providers-... endpoints
    // Introduced 2021-04-01
    // Remove when log messages no longer come
    if (hash.startsWith('providers')) {
        window.getRequest('app/log', {
            message: `Intercepted someone using a forbidden word at #${hash}`,
        })
        hash = hash.replace('providers', 'partners')
    }
    var tabName = ''
    var tabArgs = null

    if (hash) {
        // Funny way to split hash at the first "-" and only the first
        var hashParts = hash.split('-')
        tabName = hashParts.shift()

        var tabArgsRaw = hashParts.join('-')
        if (tabArgsRaw) {
            try {
                tabArgs = JSON.parse(decodeURIComponent(tabArgsRaw))
            } catch (err) {
                console.log('Unparseable hash', hash)
            }
        }
    }

    return {
        hash: hash,
        tabName: tabName,
        tabArgs: tabArgs
    }
}

// Call this whenever your current tab name stays the same but tabArgs changes.
function updateCurrentTabArgs(args) {
    window.__currentTabArgs = args
    var tabName = getTabNameAndArgsFromCurrentHash().tabName
    setLocationHashStealthily(tabName, args)
}

// Try to parse current tab and its arguments from location.hash.
// Then go to that tab, or the default tab if there was no hash (or tab was not found)
function goToCurrentTabOrDefault(defaultTab) {
    var currentTabStateFromHash = getTabNameAndArgsFromCurrentHash()

    if (currentTabStateFromHash.hash.startsWith('new')) {
        log(
            '[Old app]: the new Vue app will handle this hashchange.', currentTabStateFromHash.hash)
        return
    }

    var tabName = currentTabStateFromHash.tabName
    var tabArgs = currentTabStateFromHash.tabArgs

    if (tabArgs) {
        // Save it in global variable so the view creation function can access it
        window.__currentTabArgs = tabArgs
    }

    var $currentTabButton = $('.tabButton-' + tabName)
    if ($currentTabButton.length) {
        // For some reason the movement is still triggered by a mousedown
        $currentTabButton.first().trigger('mousedown')
        window.__currentTabArgs = null
    } else {
        console.log('Tab not found', tabName)
        if (defaultTab) {
            location.hash = defaultTab
        } else {
            $('.tabButton').first().trigger('mousedown')
        }
    }
}

function createAlignMiddle(content) {
    var container = $('<div>').css({
        display: 'table'
    })
    var cell = $('<div>').css({
        display: 'table-cell',
        'vertical-align': 'middle'
    }).appendTo(container)

    cell.append(content)

    return container
}

function createTabButton(text, callback, tabName, linkHref) {
    var button = $('<div>').text(text).addClass('tabButton')

    if (tabName !== undefined) {
        button.addClass('tabButton-' + tabName)
        button.attr('tabButtonTabName', tabName)
    }

    var clickCallback = function(event) {
        if (event && event.originalEvent) {
            // Tab clicked for real. Not programmatically clicked.
            updateCurrentTabArgs('')
        }

        if (window._dialog && window._dialog.hasChangedValues()) {
            if (!window._dialog.confirmLeave()) {
                return
            }
        }

        if (linkHref && window.redirect) {
            window.redirect(linkHref)
            return
        }

        button.blur()
        if (button.attr('disabled')) return
        callback(button.hasClass('selected'))
        window.scrollTo(0, 0)
        $('.topBar .tabButton').removeClass('selected')
        $('.topBar .topBarMenu').hide()
        $('.topBarMenuModalLayer').remove()

        if (tabName !== undefined) {
            setTimeout(function() {
                $('.tabButton-' + tabName).addClass('selected')
            }, 0)

            if (tabName) {
                setLocationHashStealthily(tabName, window.__currentTabArgs)
            }
            else
                window.removeHash()
        } else {
            setTimeout(function() {
                button.addClass('selected')
            }, 0)
            window.removeHash()
        }
    }

    button.on('mousedown touchstart', clickCallback)

    button.copyTabButton = function() {
        return createTabButton(text, callback, tabName)
    }

    if (!text) button.hide()

    return button
}

function createIconButton(iconUrl, callback) {
    var img = $('<img>').attr('src', iconUrl).addClass('iconButton')
    img.click(function() {
        img.blur()
        if (img.attr('disabled')) return
        callback()
    })
    return img
}

function createImageWithTextButton(imgUrl, text, callback) {
    var div = $('<div>').addClass('imageWithTextButtonContainer').click(function() {
        div.blur()
        if (div.attr('disabled')) return
        callback()
    })
    $('<img>').attr('src', imgUrl).appendTo(div)
    $('<div>').addClass('imageWithTextButtonText').text(text).appendTo(div)
    return div
}

function createTextButton(text, callback, href, targetBlank) {
    var button = $(href ? '<a>' : '<span>').text(text).addClass('textButton')
    if (href) {
        button.attr('href', href)

        if (targetBlank)
            button.attr('target', '_blank')
    }
    button.click(function(e) {
        if (button.attr('disabled')) {
            e.preventDefault()
            return
        }
        callback(e)
    })
    return button
}

// unused
function createModalButton(text, callback) {
    var button = $('<button>').addClass('modal-button').attr('text', text).text(text).click(function(e) {
        e.stopPropagation()
        e.preventDefault()
        button.blur()
        if (button.attr('disabled')) return
        callback()
    })
    return button
}

// unused
function createBigButton(text, callback) {
    var button = $('<button>').text(text).addClass('bigButton')
    var clickCallback = function() {
        button.blur()
        if (button.attr('disabled')) return
        callback()
    }
    button.click(clickCallback)
    return button
}

function createBasicButton(text, callback, optionalExtraClass) {
    var button = $('<button>').text(text).addClass('basicButton').click(function(e) {
        e.stopPropagation()
        e.preventDefault()
        button.blur()
        if (button.attr('disabled')) return
        callback(e)
    })
    button.addClass(optionalExtraClass)
    return button
}

function createNavigationButton(text, callback, iconUrl) {
    var button = $('<div>').addClass('navigationButton selectNone').click(function(e) {
        e.stopPropagation()
        e.preventDefault()
        button.blur()
        if (button.attr('disabled')) return
        callback(e)
    })

    button.append($('<span>').addClass('navigationButtonText').text(text))
    if (iconUrl) {
        button.append($('<img>').addClass('navigationButtonIcon').attr({
            src: iconUrl
        }))
    }
    button.append($('<img>').addClass('navigationButtonArrowIcon').attr({
        src: '/common/img/icon_arrow_small.png'
    }))

    return button
}

function addModalLayer(clickCallback, className) {
    $('body').append($('<div>').addClass('modalLayer' + (className ? ' ' + className : '')).click(function() {
        $(this).remove()
        if (clickCallback)
            clickCallback()
    }))
}

// logo: true | false: use ResQ logo as the center element
// centerElement: DOM or jQuery element.
//
// You can add both logo and centerElement - hide one of them when you know which one to show
// (which usually happens long after the top bar has been created)
//
// If you need to choose the visibility of the logo element afterwards, you can get it (the
// jQuery element) from <the return value of this function>.__logoElement if it was created.
// Use the class .hidden to hide it. (Works only if app/css/uiElements.css is included.)
function createTopBar(tabs, options) {
    options = $.extend({
        logo: true,
        language: true,
        logoutCallback: null,
        burgerMenuWidthLimit: 800,
        container: $('body'),
    }, options)

    var topBar = $('<div>').addClass('topBar')

    var menuContainer = $('<div>').addClass('topBarMenu').appendTo(topBar)

    var burgerButton = $('<div>').addClass('topBarBurgerButton').append($('<img>').attr('src', '/common/img/burger_icon.svg')).click(toggleTopBarMenu)
    topBar.append(burgerButton)

    var burgerViewAvailable = options.logoutCallback || tabs

    var view = ''
    function setBurgerView(isBurgerView) {
        if (isBurgerView && burgerViewAvailable) {
            if (view === 'burger') return
            view = 'burger'
            $('.topBarElement').hide()
            menuContainer.fadeOut()
            burgerButton.show()
            logo.removeClass('logoLeft')
            $('.topBarMenuModalLayer').remove()
        } else {
            if (view === 'normal') return
            view = 'normal'
            $('.topBarElement').show()
            menuContainer.fadeOut()
            burgerButton.hide()
            if (tabs) logo.addClass('logoLeft')
            $('.topBarMenuModalLayer').remove()
        }
    }
    function resizeCallback() {
        setBurgerView($(window).width() < options.burgerMenuWidthLimit)
    }
    if (burgerViewAvailable)
        $(window).resize(resizeCallback)

    function toggleTopBarMenu() {
        if (menuContainer.is(':visible')) {
            menuContainer.fadeOut()
            $('.topBarMenuModalLayer').remove()
        }
        else {
            menuContainer.fadeIn()
            addModalLayer(function() {
                menuContainer.fadeOut()
            }, 'topBarMenuModalLayer')
        }
    }

    if (tabs && tabs.length > 0) {
        setTimeout(function() {
            var defaultTabName = tabs[0].attr('tabButtonTabName')
            installHashChangeHandler()
            goToCurrentTabOrDefault(defaultTabName)
        }, 10)

        var tabContainer = $('<div>').addClass('tabContainer topBarElement').appendTo(topBar)
        tabContainer.append(tabs)

        var tabCopies = tabs.map(function(tab) { return tab.copyTabButton() })
        menuContainer.append(tabCopies)
    }

    let centerElementWrapper

    if (options.centerElement) {
        centerElementWrapper = $('<div class="topBar-centerElementWrapper">')
        options.centerElement.appendTo(centerElementWrapper)
        centerElementWrapper.appendTo(topBar)
    }

    let logo

    if (options.logo) {
        var logoUrl = '/common/img/resq_logo.png'
        logo = $('<a>')
            .attr('href', '/')
            .addClass('logo ' + (tabs ? ' logoLeft' : ''))
            .append($('<img>').attr('src', logoUrl))

        logo.appendTo(topBar)
    }

    if (options.language) {
        topBar.append(createLanguageController().addClass('topBarElement'))
        menuContainer.append(createLanguageController())
    }
    if (options.logoutCallback) {
        var logoutText = window.lang ? lang.logout.logOut : 'Log out'
        topBar.append(createTextButton(logoutText, options.logoutCallback).addClass('topBarElement topBarLogoutButton'))
        menuContainer.append(createTabButton(logoutText, options.logoutCallback).addClass('topBarLogoutButton'))
    }

    topBar.css({ visibility: 'hidden' })
        .prependTo(options.container)
        .css({ visibility: 'visible' })

    resizeCallback()

    var SHOW_DEV_TOP_BAR = false
    if (SHOW_DEV_TOP_BAR && window.env && use.env.DEV_ENV) {
        topBar.css({
            'background': '#4B6827',
        })
        if (logo) {
            logo.text('DEV Environment')
        }
    }

    var wrapper = $('<div>').addClass('topBarWrapper')

    var result = topBar.wrap(wrapper)

    result.__centerElementWrapper = centerElementWrapper
    result.__logoElement = logo

    wrapper = result.parent()

    var searchArea = $('<div>').addClass('topBarSearchArea')
    wrapper.append(searchArea)

    searchArea.addClass('topBarSearchArea-hidden')

    function searchTag(name) {
        return $('<div>').addClass('searchTag').text(name)
    }

    return result
}

function createLanguageController() {
    var languageSelectorContainer = $('<div>').addClass('languageSelector-touchArea')

    var languageSelectorCurrent = $('<div />').addClass('current-lang')
    var language = window.getLanguage()
    var languageSelector = $('<div>').addClass('languageSelector')

    languageSelectorCurrent.append($('<div class="text-allcaps">').text(language).css('display', 'inline-block'))
    languageSelectorCurrent.append($('<span class="icon-arrow-down">').css('margin-left', 4))
    languageSelectorContainer.append(languageSelectorCurrent)
    window.wait.env.then(function() {
        var languages = use.env.SUPPORTED_LANGUAGES
        var otherLanguages = languages.slice()
        var currentLanguage = otherLanguages.indexOf(language)
 
        otherLanguages.forEach(function(language) {
            var languageContainer = $('<div>')
            languageContainer.addClass('language')
            languageContainer
                .append($('<span class="language-short text-allcaps">'+ language +'</span>'))

            languageSelector.append(languageContainer)
        })
    })

    languageSelector.on('click', 'div', function(ev) {
        var nextLang = $(ev.target).text().toLowerCase()
        if (nextLang && nextLang !== language) {
            window.setLanguageAndReload(nextLang)
        }
    })

    languageSelectorContainer.click(function(ev) {
        languageSelectorContainer.toggleClass('open')
        ev.stopPropagation()
    })
    $('html').click(function() {
        languageSelectorContainer.removeClass('open')
    })
    languageSelectorContainer.append(languageSelector)

    return languageSelectorContainer
}



// Input stuff
//////////////////////////////

function validateTime(input) {
    var val = input.val()
    var vals = val.split(':')
    var newVal = null

    if (val == '') {
        newVal = ''
    }
    else if (vals.length >= 2) {
        var val1 = parseInt(vals[0])
        var val2 = parseInt(vals[1])
        if (!isNaN(val1) && val1 >= 0 && val1 < 24)
        {
            val1 = ('0' + val1).slice(-2)

            if (!isNaN(val2) && val2 >= 0 && val2 < 60)
            {
                val2 = ('0' + val2).slice(-2)
            }
            else
                val2 = '00'

            newVal = val1 + ':' + val2
        }
    }
    else if (vals.length == 1) {
        val = parseInt(vals[0])
        if (!isNaN(val) && val >= 0 && val < 24) {
            newVal = ('0'+val).slice(-2) + ':00'
        }
    }

    if (newVal)
    {
        input.val(newVal)
        input.data('val', newVal)
    }
    else
    {
        input.val(input.data('val'))
    }
}
function validateTimeOld(input) {
    input.data('val', input.val())
    input.change(function() {
        validateTime(input)
    })
}
function validateAmount(input) {
    input.data('oldVal', input.val())
    input.change(function() {
        var val = input.val()
        if (val == '') {
            input.data('oldVal', val)
            return
        }
        var num = parseInt(val)
        if (isNaN(num) || num <= 0)
        {
            input.val(input.data('oldVal'))
        }
        else {
            input.val(num)
            input.data('oldVal', input.val())
        }
    })
    input.change()
}

function validateLocation(input) {
    input.data('oldVal', input.val())

    function handler() {
        var val = input.val()
        if (val == '') {
            input.data('oldVal', val)
            input.val('')
            return
        }
        var num = parseFloat(val)
        if (isNaN(num) || num < -180 || num > 180)
        {
            input.val(input.data('oldVal'))
        }
        else {
            input.val(num)
            input.data('oldVal', input.val())
        }
    }

    input.change(handler)
    handler()
}

function createInputLabel(title, subTitle) {
    if (subTitle) subTitle = ' (' + subTitle + ')'
    else subTitle = ''
    return $('<div>').addClass('inputBlockTitle').text(title + subTitle)
}

function createSimpleInputBlock(localizationObject, type, defaultValue, horizontalAlign, width) {
    if (!localizationObject)
        localizationObject = {}
    else if (typeof localizationObject == 'string')
        localizationObject = { title: localizationObject }
    var title = localizationObject.title || ''
    var name = title.replace(/[ -]/g, '_') || ('' + Math.random())
    var placeholder = localizationObject.placeholder || ''
    return createInputBlockOld(name, title, placeholder, type, defaultValue, horizontalAlign, width)
}

function createInputBlock(options) {
    var defaultOptions = {
        label: '', // overrides localization
        placeholder: '', // overrides localization
        localization: '', // string or { label: "", placeholder: "" }
        size: 'full', // full/half/halfRight/auto/fixed
        blockClass: '',
        inputClass: '',
        type: 'text', // select option type is: [{ id: "fi", name: "Finland" }, ...]
        value: '', // default value
    }
    options = $.extend(defaultOptions, options)

    var block = $('<div>').addClass('inputBlock inputBlock-' + options.size + ' inputBlock-type-' + options.type)
    if (options.blockClass) block.addClass(options.blockClass)

    var label = options.label || options.localization && options.localization.label

    if (label) {
        var inputLabel = createInputLabel(label)
        block.append(inputLabel)
    }

    var input = createInput($.extend({}, options, {
        class: options.inputClass,
        width: '100%',
        placeholder: options.placeholder || options.localization && options.localization.placeholder,
    }))

    block.append(input)
    block.data('changed', false)
    block.data('get', input.data('get'))
    block.data('set', input.data('set'))
    block.data('change', input.data('change'))
    block.data('type', input.data('type'))
    block.data('input', input)
    block.data('value', input.data('get')())
    input.data('change')(function() {
        block.data('changed', true)
        block.data('value', input.data('get')())
    })

    block.css({ display: 'inline-block' }) // TODO: move this to css when refactoring is done

    // Clear button for search input must be added here
    if (options.type === 'search') {
        var clearSearch = $('<div class="clearSearch">&times;</div>')
        clearSearch.click(function() {
            input.val('')
            clearSearch.hide()
            if ($.isFunction(options.onChange)) {
                options.onChange()
            }
        })

        const handleInputChange = function() {
            if (input.val() === '') {
                clearSearch.hide()
            } else {
                clearSearch.show()
            }
            if ($.isFunction(options.onChange)) {
                options.onChange()
            }
        }

        input.keyup(handleInputChange)
        input.change(handleInputChange)

        block.append(clearSearch.hide())
    }

    return block
}

function createInput(options) {
    var defaultOptions = {
        placeholder: '',
        width: '100%', // default 100%. in small screens width is forced to 100%.
        class: '',
        label: '', // some inputs needs label in input element (checkbox)
        type: 'text', // select option type is: [{ id: "fi", name: "Finland" }, ...]
        value: '',
    }
    options = $.extend(defaultOptions, options)

    if (!inputTypes[options.type])
        alert('type ' + options.type + ' not supported')

    var type = $.extend({}, inputTypes.text, inputTypes[inputTypes[options.type].inherits], inputTypes[options.type])

    var input = type.create(options).addClass('basicInput basicInput-type-' + options.type)

    type.init(input, options)
    var realInput = type.getInputElement(input)
    if (realInput) {
        realInput.attr({
            type: type.type,
            placeholder: options.placeholder
        })
    }
    if (options.class) input.addClass(options.class)
    type.set(input, options.value)
    type.validate(input)
    if (realInput) {
        realInput.change(function() {
            type.validate(input)
        })
    }
    input.data('type', type)
    input.data('get', function() {
        return type.get(input)
    })
    input.data('set', function(val) {
        type.set(input, val)
        if (realInput)
            realInput.change()
    })
    if (realInput) {
        input.data('change', function(listener) {
            realInput.change(listener)
        })
    }

    if (options.allowedCharacters) {
        const allowedKeyCodes = new Set()
        for (const char of options.allowedCharacters) {
            allowedKeyCodes.add(char.charCodeAt(0))
        }

        realInput.attr({ allowedKeyCodes: Array.from(allowedKeyCodes) })

        realInput.on('keypress', function(e) {
            if (!allowedKeyCodes.has(e.keyCode)) {
                e.preventDefault()
            }
        })
    }

    return input
}

var inputTypes = {
    text: {
        inherits: 'text', // cannot inherit inherited
        type: 'text',
        create: function() {
            return $('<input>')
        },
        init: function(input) {
        },
        validate: function(input) {
        },
        set: function(input, value) {
            input.val(value)
        },
        get: function(input) {
            return input.val()
        },
        getInputElement: function(rootElement) {
            // if this returns null, you must have your own setter, change-listener and call change on set
            return rootElement
        }
    },
    username: {},
    email: {
        type: 'email',
        init: function(input) {
            input.attr({
                'name': 'email',
                'autocomplete': 'on'
            })
        }
    },
    password: {
        type: 'password',
    },
    location: {
        set: function(input, value) {
            input.val(value)
            input.data('oldVal', input.val())
        },
        validate: function(input) {
            var val = input.val()
            if (val == '') {
                input.data('oldVal', val)
                input.val('')
                return
            }
            var num = parseFloat(val)
            if (isNaN(num) || num < -180 || num > 180)
            {
                input.val(input.data('oldVal') || '')
            }
            else {
                input.val(num)
                input.data('oldVal', input.val())
            }
        }
    },
    textarea: {
        create: function() {
            return $('<textarea>')
        },
        init: function(input) {
        }
    },
    number: {
        type: 'number',
        get: function(input) {
            return parseFloat(input.val())
        },
    },
    checkbox: {
        type: 'checkbox', // doesn't work because of container
        create: function(options) {
            var container = $('<div>')
            var name = 'checkbox_' + Math.random()
            var input = $('<input>').attr({
                id: name,
            }).appendTo(container)

            var label = $('<label>').text(options.label).attr({
                for: name
            }).appendTo(container)
            if (!options.label) {
                container.css('position', 'relative')
                label.addClass('checkbox-bigEmptyLabelClickArea')
                container.addClass('selectNone')
            }
            return container
        },
        init: function(input, options) {

        },
        get: function(input) {
            return input.find('input').prop('checked') ? 1 : 0
        },
        set: function(input, value) {
            input.find('input').prop('checked', value && value != 'false')
        },
        getInputElement: function(rootElement) {
            return rootElement.find('input')
        }
    },
    radio: {
        type: 'radio', // doesn't work because of container
        create: function(options) {
            var container = $('<div>').addClass('radioButtonContainer')
            var rnd = ''+Math.random()
            rnd = rnd.substring(3)
            var name = 'radio_' + rnd

            options.radioElements.forEach(function(e) {
                var div = $('<div>').addClass('radioButtonElement')

                var radioButton = $('<input>').attr({
                    type: 'radio',
                    name: name,
                    id: name + '_' + e.id,
                    value: e.id
                }).appendTo(div)

                if (options.radioValue == e.id || e.checked) {
                    radioButton.prop('checked', true)
                }

                var label = $('<label>').attr('for', name + '_' + e.id).append(e.label || 'Radio button without label')
                div.append(label)

                container.append(div)
            })

            container.data('change', function(listener) {
                container.find('input:radio[name='+name+']').change(listener)
            })

            return container
        },
        get: function(input) {
            return input.find('input:checked').val()
        },
        set: function(input, value) {
            input.find('input[value="' + value + '"]').prop('checked', true)
            input.find('input:radio').change()
        },
        getInputElement: function(rootElement) {
            return null
        }
    },
    range: {
        type: 'range',
        init: function(input, options) {
            if (options.rangeOptions) {
                input.attr(options.rangeOptions)
            }

            input.data('inputEvent', function(listener) {
                input.on('input', listener)
            })
        },
    },
    search: {
        inherits: 'text',
        //type: 'text', // Can't use type="search" because of inconsistent implementation in browsers
    },
    time: {
        validate: validateTime,
        get: function(input) {
            if (input.val().length <= 1)
                return null
            else
                return input.val() + ':00' // 00:00 -> 00:00:00
        },
        set: function(input, value) {
            log('setting', value)
            if (typeof value == 'string' && value.length > 10)
                value = new Date(value)

            log('setting2', value)

            if (value instanceof Date) {
                value = value.toTimeString()
            }
            log('setting3', value)

            if (!value)
                value = ''

            input.val(value.substring(0, 5))
        },
    },
    select: {
        create: function(options) {
            return createInputBlockOld('select', null, options.placeholder, 'select', options.value, null, null, options.selectOptions)
        },
        init: function(input, options) {
            // This is a hack that makes this hacky wrapper look good
            input.removeClass('basicInput')
        },
        get: function(input) {
            return input.input.val()
        },
        getInputElement: function(rootElement) {
            return rootElement.input
        },
    }
    // TODO ...
}


function createInputBlockOld(name, title, placeholder, type, defaultValue, horizontalAlign, width, optionalOptions) {
    var div = $('<div>').addClass('inputBlock')
    if (title && type != 'checkbox') {
        var inputTitle = createInputLabel(title)
        inputTitle.attr('id', 'inputTitle_' + name)
        div.append(inputTitle)
    }

    var options = optionalOptions || {}
    var tag
    var wrap = false
    if (type === 'textarea') {
        tag = '<textarea>'
    } else if (type === 'select') {
        tag = '<select>'
        wrap = true
    } else {
        tag = '<input>'
    }

    var input = $(tag).attr({
        placeholder: placeholder,
        id: 'input_' + name
    }).addClass('basicInput').val(defaultValue)

    var result

    if (wrap) {
        var wrapper = $('<div class=inputWrapper>').addClass('inputWrapper-' + type).append(input)
        div.append(wrapper)
    } else {
        div.append(input)
    }
    if (type === 'textarea') {
        setTimeout(function() {
            input.autogrow({vertical: true, horizontal: false, flickering: false})
        },0)

    }

    if (horizontalAlign) {
        div.css({
            float: horizontalAlign,
            width: width,
            display: 'inline-block'
        })
    } else {
        div.css('clear', 'both')
    }

    var getValueFunc = function() { return input.val() }

    input.change(function() {
        input.attr('changed', true)
        div.attr('changed', true)
        getValueFunc.changed = true
    })

    if (type == 'text') {
        input.attr('type', 'text')
    } else if (type == 'username') {
        input.attr('type', 'text')
    } else if (type == 'email') {
        input.attr({
            'type': 'email',
            'name': 'email',
            'autocomplete': 'on'
        })
    } else if (type == 'password') {
        input.attr('type', 'password')
    } else if (type == 'location') {
        input.attr('type', 'text')
        validateLocation(input)
    } else if (type == 'textarea') {
        /*
		 input.css({
		 height: "80px"
		 });
		 */
    } else if (type == 'amount') {
        input.attr('type', 'number')
        validateAmount(input)
    } else if (type == 'number') {
        input.attr('type', 'number')
    } else if (type == 'checkbox') {
        input.attr('type', 'checkbox')
        input.css({
            'width': 'auto',
            'vertical-align': 'top'
        })
        div.append(
            $('<label>')
                .text(title)
                .attr('for', 'input_' + name)
                .css({
                    'vertical-align': 'top',
                    'padding-left': '10px',
                    'user-select': 'none'
                })
        ).append($("<div style='clear: both'>"))
        if (defaultValue && defaultValue != 'false')
            input.prop('checked', true)
        getValueFunc = function() { return input.prop('checked') ? 1 : 0 }
    } else if (type == 'time') {
        div.addClass('timeInputBlock')
        input.attr('type', 'text').addClass('timeInput')
        if (defaultValue) {
            if (typeof defaultValue == 'string' && defaultValue.length > 10)
                defaultValue = new Date(defaultValue)

            if (defaultValue instanceof Date) {
                defaultValue = defaultValue.toTimeString().substr(0, 5)
            }

            input.val(defaultValue.substring(0, 5)) // 00:00:00 -> 00:00
        }
        validateTimeOld(input)
        getValueFunc = function() {
            return input.val() + ':00' // 00:00 -> 00:00:00
            /*
			 var split = input.val().split(":");
			 return new Date(0, 0, 0, split[0], split[1]).toISOString();
			 */
        }
    } else if (type === 'select') {
        var values = options.values || []
        var labels = options.labels || values
        values.forEach(function(value, idx) {
            var label = labels[idx]
            var option = $('<option>').attr('value', value).text(label)
            if (String(value) === String(defaultValue)) {
                option.attr('selected', 'selected')
            }
            input.append(option)
        })
    }

    div.input = input
    div.getValueFunc = getValueFunc
    return div
}


function createTextCheckbox(text, id, callback) {
    var button = $('<span>').text(text).attr('id', id).addClass('textCheckbox').click(function() {
        if (button.attr('disabled')) return
        button.toggleClass('selected')
        if (callback) {
            callback(button.hasClass('selected'))
        }
    })
    return button
}

/*
 items = [{text, value}]
 callback = function(value) {}
 */
function createMenu(defaultValue, items, callback) {
    var ul = $('<ul>')

    function addItems(items) {
        items.forEach(function(item) {
            var li = $('<li>').attr({
                value: item.value,
            }).text(item.text)

            if (item.value == defaultValue) {
                li.css({
                    fontWeight: 'bold',
                })
            }

            ul.append(li)
        })

        setTimeout(function() {
            ul.menu({
                select: function(event, ui) {
                    if (callback)
                        callback($(event.currentTarget).attr('value'))
                    ul.menu('destroy').remove()
                }
            })
        }, 10)

        return ul
    }

    if (items) addItems(items)
    ul.addItems = addItems

    return ul
}
; /* START FILE common/js/modalDialog.js */ /* modalDialog.js */

// emulates alert()
//
// Show alert. Return promise that resolves after alert has been dismissed.
// The returned promise never rejects.
//
// title: "Hups!" by default
// optionalClass: class to be added to alert, e.g. "alert-wide"
// raw: "raw" if alert is message contains HTML (otherwise it will be escaped). Also jquery element is supported
function showAlert(message, title, optionalClass /* e.g. "alert-wide" */, raw, okText) {
    if (title == null) {
        title = window.lang ? lang.common.oops : 'Oops!'
    }

    if (!okText) {
        okText = 'OK'
    }

    var promise = $.Deferred()

    var alertBackground = $('<div class=alert-background>').click(function(ev) {
        if (ev.target === this) {
            dismiss()
        }
    })

    function dismiss() {
        alertBackground.remove()
        promise.resolve()
    }

    var alertWrapper = $('<div class=alertWrapper>').appendTo(alertBackground)
    var alert = $('<div class=alert>').appendTo(alertWrapper)

    if (optionalClass) {
        alert.addClass(optionalClass)
    }
    alert.append($('<h1>' + title + '</h1>'))
    var messageElement = $('<div class=messageAlert>')
    alert.append(messageElement)
    if (raw) {
        messageElement.append(message)
    } else {
        messageElement.text(message)
    }

    alert.append(window.createBasicButton(okText, dismiss))

    var oldKeyDown = window.onkeydown
    window.onkeydown = function(e) {
        var ESC = 27
        if (e.keyCode == ESC) {
            window.onkeydown = oldKeyDown
            dismiss()
        }
    }

    alertBackground.appendTo(document.body)

    return promise
}

// Emulates prompt()
function showPrompt(question, options) {
    if (options === undefined) {
        options = {}
    }

    return showConfirm(question, options.placeholder, options.defaultValue, 'text', options.buttonText)
}

function showConfirm(question, placeholder, defaultValue, inputType, buttonText, hideAnswer) {
    placeholder = placeholder || ''
    defaultValue = defaultValue || ''
    inputType = inputType || 'text'

    return new Promise(function(resolve, reject) {
        var dlg = new ModalDialog('', {})

        dlg.add($('<p>').text(question).addClass('question'))
        if (!hideAnswer) {
            var answer = dlg.addInputOld('answer', '', placeholder, inputType, defaultValue)
            var button = dlg.addButton(buttonText || lang.common.ok, function() {
                resolve(answer.input.val())
                dlg.hide()
            })
            // Simulate a form with <input type=submit>
            answer.input.on('keypress', function(ev) {
                if (ev.keyCode === 13) {
                    button.click()
                }
            })
        } else {
            dlg.addButton(buttonText || lang.common.ok, function() {
                resolve()
                dlg.hide()
            })

        }

        dlg.show()
        setTimeout(function() {
            answer.input.focus()
        }, 100)
    })
}

/*
 var data = {}
 for (var i = 0; i < dlg.values.length; i++) {
 if (!dlg.values[i].valueName) continue;
 if (dlg.values[i].changed || (dlg.values[i].inputBlock && dlg.values[i].inputBlock.data("changed")))
 data[dlg.values[i].valueName] = dlg.values[i]();
 }

 console.log("data", data)
 * */

function ModalDialog(title, opts) {
    var defaultOptions = {
        width: 'auto', // content max width. (for example "600px" or "50vw")
        submitFromEnter: false,
        popup: true,
        saveOnlyEdited: false,
        hideCallback: null,
        preventLeaveOnChanges: false,
        class: ''
    }
    opts = $.extend(defaultOptions, opts)
    var self = this

    var background = $('<div>').addClass('modal-background').click(function() {
        self.hide('dismissed')
    })
    var dialogContainer = $('<div>').addClass('modalDialog-container').click(function() {
        self.hide('dismissed')
    })
    var dialog = $(opts.submitFromEnter ? '<form>' : '<div>').addClass('modalDialog').appendTo(dialogContainer)
    if (opts.class) {
        dialog.addClass(opts.class)
    }
    dialog.click(function(e) {
        if (opts.popup)
            e.stopPropagation()
    })
    /*
	 var data = {}
	 for (var i = 0; i < dlg.values.length; i++) {
	 if (!dlg.values[i].valueName) continue;
	 if (dlg.values[i].changed || (dlg.values[i].inputBlock && dlg.values[i].inputBlock.data("changed")))
	 data[dlg.values[i].valueName] = dlg.values[i]();
	 }

	 console.log("data", data)
	 * */

    // if (opts.width) dialog.css("width", opts.width);
    /*

	 */

    window._dialog = this

    $(window).on('hashchange', function(e) {

        //return confirm("You sure?")
    })

    if (!opts.popup)
        dialog.addClass('modalDialog-nonpopup')

    this.addHorizontalLine = function(container) {
        return $('<div>').addClass('modal-horizontalLine').appendTo(container || body)
    }

    if (title) {
        $('<div>').addClass('modal-title modalPopupSection').append(
            $('<h2>').append(title).addClass('green comic')).appendTo(dialog)
    } else {
        var div = $('<div>')
        div.css('height', '20px')
        div.appendTo(dialog)
    }

    if (opts.popup) {
        var closeButton = $('<div>').addClass('modalCloseButton').append(
            $('<img>').attr('src', '/common/img/icon_close.png')).appendTo(dialog).click(function() {
            if (!closeButton.attr('disabled')) {
                self.hide('dismissed')
            }
        })
    }
    var body = $('<div>').addClass('modalBody modalPopupSection').appendTo(dialog)

    this.getBody = function() {
        return body
    }

    var footer = $('<div>').addClass('modalFooter modalPopupSection').appendTo(dialog)

    if (opts.width) {
        dialog.find('.modalPopupSection').css({
            maxWidth: opts.width,
        })
        dialog.append($('<div>').width(opts.width).attr('reason', 'this block defines desired width'))
    }

    var values = []
    this.values = values

    var layoutWidth = 12 // align width, not real width
    var i = 0 // align position
    this.confirmLeave = function() {
        if (opts.preventLeaveOnChanges) {
            return window.escapedConfirm(lang.settings.myInfo.unsavedChanges.confirmText)
        }
        return

    }
    this.hasChangedValues = function() {
        if (!opts.preventLeaveOnChanges) {
            return false
        }
        var dlg = this

        var data = {}
        for (var i = 0; i < dlg.values.length; i++) {
            if (!dlg.values[i].valueName) continue
            if (dlg.values[i].changed || (dlg.values[i].inputBlock && dlg.values[i].inputBlock.data('changed')))
                data[dlg.values[i].valueName] = dlg.values[i]()
        }
        var changedProviderDLTimeInputs = $('.ProviderDLTimeInput input').toArray().map(function(input) {
            return $(input).val()
        }).toString()
        //console.log("checking for changes", this.values, data, changedProviderDLTimeInputs);
        return Object.keys(
            data).length > 0 || (this.savedProviderDLTimeInputs && changedProviderDLTimeInputs && this.savedProviderDLTimeInputs !== changedProviderDLTimeInputs)
    }
    this.addInput = function(options) {
        var appendToFooter = !!options.appendToFooter
        var block = window.createInputBlock(options)

        var s = options.size
        var w = 0 // align width, not real width
        if (s == 'half') {
            w = 6
            if (i % 6 != 0) this.add($('<br>'))
        }
        else if (s == 'big') w = 11
        else if (s == 'small') w = 1
        else if (s == 'auto') w = 1.234567

        if (!w) i = 0
        if (i > 0) block.addClass('inputBlock-notFirst')
        i = (i + w) % layoutWidth;

        (appendToFooter ? footer : body).append(block)

        if (options.name) {
            var getValueFunc = function() {
                const callFunc = block.data('get');
                if (callFunc) {
                  return callFunc()
                }
            }
            getValueFunc.valueName = options.name
            getValueFunc.inputBlock = block

            values.push(getValueFunc)
        }

        return block
    }

    this.addInputOld = function(name, title, placeholder, type, defaultValue, horizontalAlign, width) {
        var div = window.createInputBlockOld(name, title, placeholder, type, defaultValue, horizontalAlign, width)

        body.append(div)

        var getValueFunc = div.getValueFunc
        getValueFunc.input = div.input
        getValueFunc.valueName = name
        getValueFunc.container = div
        values.push(getValueFunc)
        return getValueFunc
    }

    // Sometimes you need to create an input block and then append things to it manually.
    // You can use this and then pass the returned input block as 'container' parameter to the
    // things that you append to it.
    this.addInputBlock = function(style = null) {
        var div = $('<div>').addClass('inputBlock')
        if (style) {
            div.attr('style', style)
        }
        div.appendTo(body)
        return div
    }

    this.addInputTitle = function(title, subTitle, container) {
        container = container || body
        if (subTitle) subTitle = ' (' + subTitle + ')'
        else subTitle = ''
        $('<div>').addClass('inputBlockTitle').text(title + subTitle).appendTo(container)
    }

    this.add = function(div) {
        body.append(div)
        return div
    }

    this.addToFooter = function(div) {
        footer.append(div)
        return div
    }

    function createButton(text, callback, optionalExtraClass) {
        return window.createBasicButton(text, function() {
            var data = {}
            for (var i = 0; i < values.length; i++) {
                if (!values[i].valueName) continue
                if (!opts.saveOnlyEdited || values[i].changed || (values[i].inputBlock && values[i].inputBlock.data(
                    'changed')))
                    data[values[i].valueName] = values[i]()
            }

            dialog.find('*').attr('disabled', true)
            callback.apply(null, [data])
        }, optionalExtraClass).addClass('modal-button')
    }

    this.addBodyButton = function(text, callback, optionalExtraClass, container) {
        var button = createButton(text, callback, optionalExtraClass)
        container = container || body
        container.append(button)
        return button
    }

    this.addButton = function(text, callback, optionalExtraClass) {
        var button = createButton(text, callback, optionalExtraClass || 'basicConfirmButton')
        footer.append(button)
        return button
    }

    this.addCancelButton = function() {
        console.log('addCancelButton not supported anymore')
        return
    }
    this.addTextButton = function(text, callback, href, targetBlank) {
        var button = window.createTextButton(text, callback, href, targetBlank)

        footer.append($('<div>').css('clear', 'both'), button)
        return button
    }

    this.addClear = function() {
        this.add($('<div>').css('clear', 'both'))
    }
    this.disableAll = function() {
        dialog.find('*').attr('disabled', true)
    }
    this.enableAllAgain = function() {
        dialog.find('*').attr('disabled', false)
    }

    // Show the dialog and return a promise that resolves when the dialog is hidden.
    //
    // Resolves with 'dismissed' if the dialog is cancelled (clicked outside
    // or on the close button, clicking ESC etc.) and e.g. 'saved' if the dialog
    // results in the saving of data.
    //
    // TODO this is work in progress - go over places that call .hide() and change
    // them to actually include a result.
    //
    // In general, dialog.hide(result) makes the promise returned by dialog.show()
    // resolve with the result.
    //
    this.show = function() {
        return new Promise(function(resolve, reject) {
            var oldHideCallback = opts.hideCallback
            if (opts.hideCallback) {
                opts.hideCallback = function(result) {
                    oldHideCallback(result)
                    resolve(result)
                }
            } else {
                opts.hideCallback = resolve
            }

            var scrollPosition = $(window).scrollTop()

            background.show()

            var dialog = dialogContainer.children('.modalDialog')

            dialogContainer.show()

            setTimeout(function() {
                var input = dialog.find('input').first()
                if (input.val() === '') {
                    input.focus()
                }
            }, 1)

            $('body').append(background, dialogContainer)

            var topPosition = ~~((window.innerHeight - dialog.height()) / 2)
            if (topPosition < 70)
                topPosition = 70

            if (topPosition > window.innerHeight * 0.25)
                topPosition = ~~(window.innerHeight * 0.25)

            dialog.css({ top: (scrollPosition + topPosition) + 'px' })

            var oldKeyDown = window.onkeydown
            window.onkeydown = function(e) {
                var ESC = 27
                if (e.keyCode === ESC) {
                    self.hide('dismissed')
                    window.onkeydown = oldKeyDown
                }
            }

        })
    }
    this.hide = function(result) {
        dialogContainer.hide()
        dialogContainer.remove()

        background.hide()
        background.remove()

        if (opts.hideCallback)
            opts.hideCallback(result)
    }

    this.getDialogElement = function() {
        return dialog
    }

    this.isVisible = function() {
        return dialog.is(':visible')
    }
}
; /* START FILE app/js/appUIElements.js */ function createPriceTag(price, providerOrCurrency, size, showWholeNumberAsWholeNumber) {
    // TODO find usages of (now unused) showWholeNumberAsWholeNumber and remove them
    size = size || 'normal'
    var container = $('<div>').addClass('priceTag priceTag-' + size).width(size).height(size)
    var currency = providerOrCurrency.country ? providerOrCurrency.country.currency : providerOrCurrency
    var textDiv = $('<div>').appendTo(container).addClass('priceTextDiv')
    textDiv.append('&nbsp;' + window.formatCurrency(price, currency))

    return container
}


function createMenuButton(text, callback, hasBottomBorder, color, iconUrl) {
    var button = $('<a>').text(text).addClass('menuButton')
    if (typeof callback === 'function') {
        button.click(callback)
    } else {
        button.attr(callback)
    }
    if (hasBottomBorder)
    {
        button.css({
            borderBottom: '1px solid rgba(255, 255, 255, 0.25)'
        })
    }
    if (color)
    {
        button.css({
            color: color
        })
    }

    if (iconUrl) {
        button.prepend($('<span class="'+iconUrl+'" ></span>'))
    }

    button.append('<span class="icon-arrow-right"></span>')

    return button
}

function createIcon(fileName) {
    return $('<img>').attr('src', 'img/'+fileName).addClass('offerDetailsIcon')
}

function createFontIcon(iconName) {
    var el = $('<span>')
    el.addClass(iconName)
    return el
    //return $("<img>").attr("src", "/img/icons/"+iconName + '.svg').addClass("offerDetailsIcon icon icon-svg");
}
function createInfoArea(html, hideIfSmallScreen) {
    var infoArea = $('<div>').addClass('infoArea').html(html)
    if (hideIfSmallScreen)
        infoArea.addClass('hideIfSmallScreen')
    return infoArea
}

function createFavouriteButton(provider) {
    var favText = 'Favourited'
    var text = 'Make Favourite'

    var isFavourite = window.myProfile.favouriteProviders[provider.id]

    function refresh() {
        window.updateMyProfile(window.updateNearbyProviders)
    }

    var button = $('<div>').text(isFavourite ? favText : text).click(function() {
        button.toggleClass('selected')
        if (button.hasClass('selected')) {
            button.text(favText)
            window.postRequest('app/addFavouriteProvider/' + provider.id).done(refresh)
        }
        else {
            button.text(text)
            window.postRequest('app/removeFavouriteProvider/' + provider.id).done(refresh)
        }
    }).addClass('favouriteButton')
    if (isFavourite)
        button.addClass('selected')

    return button
}

function createProfileButton() {
    var profileButton = $('<div>').attr('id', 'profileButton')

    profileButton.click(function() {
        var menu = $('#menu')
        if (menu.hasClass('down')) {
            menu.removeClass('down')
            $('.modalLayer').remove()
            $('#backButton').fadeIn()
        } else {
            menu.addClass('down')
            $('#menu input').first().focus()
            $('#backButton').fadeOut()
            window.addModalLayer(function() {
                //menu.removeClass("down");
                $('#profileButton').click()
            })
        }
    })

    return profileButton
}

function createSearchButton() {
    var button = $('<div>').attr('id', 'searchButton')

    // log('!!! create search');

    function updateSearchParameters(params) {
        window.searchParametersManager.searchParameters = params
        window.eventManager.dispatch('searchParametersUpdated')
    }


    button.click(function() {
        // Totally hacky test version
        const result = window.prompt('Search for:')
        if (typeof result === 'string') {
            updateSearchParameters({ matchString: result })
        }

        // var menu = $('#menu');
        // if (menu.hasClass('down')) {
        // 	menu.removeClass('down');
        // 	$('.modalLayer').remove();
        // 	$('#backButton').fadeIn();
        // } else {
        // 	menu.addClass('down');
        // 	$('#menu input').first().focus();
        // 	$('#backButton').fadeOut();
        // 	addModalLayer(function() {
        // 		//menu.removeClass("down");
        // 		$('#profileButton').click();
        // 	});
        // }
    })

    return button
}

function createTagButton(tag, callback, selected) {
    var button = $('<div>').addClass('tag-button').attr('tagid', tag.id)
    $('<img>').attr('src', tag.iconUrl).appendTo(button)
    $('<span>').text(tag.name).appendTo(button)
    button.click(function() {
        if (button.prop('disabled') || button.attr('disabled')) return

        button.toggleClass('selected')
        callback.call(button, button.hasClass('selected'))
    })
    if (selected)
        button.addClass('selected')
    return button
}

function createLanguageControl() {
    throw new Error('DONT USE!!!')
}

function createLocationAutocomplete(inputElement, callback, onlyCountries) {
    inputElement = $(inputElement)

    function geocode(value) {
        var geocoder = new window.google.maps.Geocoder()
        geocoder.geocode({ address: value }, function(results, status) {
            if (status == window.google.maps.GeocoderStatus.OK) {
                callback(results[0])
            }
        })
    }

    function execute() {
        var autocomplete = new window.google.maps.places.Autocomplete(inputElement[0])
        autocomplete.addListener('place_changed', function() {
            var place = autocomplete.getPlace()
            if (place) {
                if (onlyCountries) {
                    for (var i = 0; i < place.address_components.length; i += 1) {
                        var addressObj = place.address_components[i]
                        for (var j = 0; j < addressObj.types.length; j += 1) {
                            if (addressObj.types[j] === 'country') {
                                // log(addressObj);
                                inputElement.val(addressObj.short_name)
                                if (callback)
                                    callback(place)
                            }
                        }
                    }
                } else if (place.geometry) {
                    if (callback) callback(place)
                } else if (place.name) {
                    if (callback) geocode(place.name)
                } else {
                    console.log('place not found:', place)
                }
            }
        })
        inputElement.on('input', function() {
            if (!$('.pac-container').hasClass('needsclick')) {
                window.disableFastClick($('.pac-container').addClass('needsclick'))
            }
        })
    }
    if (!window.google) {
        setTimeout(execute, 2000)
    } else {
        execute()
    }

    return function() {
        // force change
        geocode($(inputElement).val())
    }
}

// changeCallback gets (newValue, previousValue)
// if previousValue === undefined, the value was probably set initially.
function createMoreLessInput(initial, min, max, changeCallback) {
    var div = $('<div>').addClass('moreLessInput selectNone')

    function getValue() {
        return ~~div.attr('value')
    }

    function setValue(value) {
        const previousValue = Number(div.attr('value'))
        div.attr('value', value)
        if (changeCallback)
            changeCallback(value, previousValue)
        updateDisabledStatus()
    }

    function updateDisabledStatus() {
        var value = ~~div.attr('value')
        less.attr('disabled', value <= min)
        more.attr('disabled', value >= max)
    }

    var less = $('<div>').addClass('moreLessInputLess').appendTo(div).click(function() {
        var value = getValue()
        if (value > min)
            setValue(value - 1)
    })
    var more = $('<div>').addClass('moreLessInputMore').appendTo(div).click(function() {
        var value = getValue()
        if (value < max)
            setValue(value + 1)
    })

    setValue(initial)

    return div
}

function createOfferTags(tags) {
    var container = $('<div>').addClass('offerDetailsBottom')

    var tagContainer = $('<div>').addClass('offerDetailsTags').appendTo(container)
    for (var i = 0; i < tags.length; i++) {
        var t = tags[i]
        var icon = $('<img>').attr('src', t.iconUrl)
        var text = $('<span>').text(t.name)
        $('<div>').addClass('offerDetailsTag').append(icon, text).appendTo(tagContainer)
    }

    return container
}

function createGoToMyLocationButton() {
    return window.createIconButton('/img/icon_locateme_grey.png', function() {
        window.goToMyLocation()
    }).addClass('goToMyLocationButton selectNone')
}
; /* START FILE app/js/map.js */ var smallMap, bigMap
var activeMap
var geocoder

function isCachedLocationKnown() {
  return window.store.get('resqLatLng') || (window.myProfile && window.myProfile.latitude)
}

function goToCachedLocation(failCallback) {
  if (isCachedLocationKnown()) {
    if (window.myProfile && window.myProfile.latitude)
      goToLocation(window.myProfile)
    else {
      try {
        var loc = JSON.parse(window.store.get('resqLatLng'))
        goToLocation({
          latitude: loc.lat,
          longitude: loc.lng
        }, ~~window.store.get('resqZoom'))
      } catch (e) {
      }
    }
  } else {
    if (failCallback)
      failCallback()
  }
}

function goToMyLocation() {
  updateMyLocation(function (location) {
    if (location) {
      goToLocation(location, 15)
    } else {
      goToCachedLocation(window.openAllowLocationPopup)
    }
  })
}

function updateMyLocation(callback) {
  var geolocationLikelyWorks = window.location.host.match(/^localhost/) || window.location.protocol === 'https:'
  if (navigator.geolocation && geolocationLikelyWorks) {
    navigator.geolocation.getCurrentPosition(function (geoPos) {
      wait.googleMaps.then(function () {
        var me = new window.google.maps.LatLng(geoPos.coords.latitude, geoPos.coords.longitude)
        if (locationMarker) {
          locationMarker.setPosition(me)
        }

        var p = geoPos.coords
        window.sendInfo(p.latitude, p.longitude)
        if (callback) callback(p)
      })
    }, function () {
      if (callback) callback(null)
      window.sendInfo()
    })
  } else {
    if (callback) callback(null)
    window.sendInfo()
  }
}

function distanceToProvider(provider) {
  //console.log("distanceToProvider", provider)
  if (window.userData && window.userData.latitude && window.userData.longitude) {
    var distance = window.calcCrow(provider.latitude, provider.longitude, window.userData.latitude, window.userData.longitude)
    //console.log('distance', distance);
    return distance
  }
}

function goToLocation(providerOrUser, zoomLevel) {
  if (!activeMap) return
  if (activeMap == smallMap && $('#smallMap').height() == 0) {
    showSmallMap()
  }
  activeMap.setCenter({lat: providerOrUser.latitude, lng: providerOrUser.longitude})
  if (zoomLevel)
    activeMap.setZoom(zoomLevel || 14)
}

var openInfoWindow = null
var markers = []
var locationMarker
var pinIcon = null

function createPinIcon() {
  pinIcon = new window.google.maps.MarkerImage(
    'img/pin.png',
    null, /* size is determined at runtime */
    null, /* origin is 0,0 */
    null, /* anchor is bottom center of the scaled image */
    new window.google.maps.Size(30, 30)
  )
  pinIcon.labelOrigin = new window.google.maps.Point(15, 12)
  return pinIcon
}


var bubble = null

function markerClicked(marker) {
  // moved to providerMarker
}


function clearMarkers() {
  for (var i = 0; i < markers.length; i++) {
    markers[i].setMap(null)
  }
  markers.length = 0
}

function moveMarkersToCurrentMap() {
  if (!activeMap) return

  for (var id in window.providerManager.providerMarkers) {
    window.providerManager.providerMarkers[id].setMap(activeMap)
  }

  if (locationMarker) {
    locationMarker.setMap(activeMap)
  }
}

function zoomLevelChanged(zoomLevel) {
  updateRadius()
  window.updateNearbyProviders()
  updateMarkerTextVisibility()
}


var _center
var _zoom
var _radius

function updateCenter() {
  _center = activeMap.getCenter()
  _zoom = activeMap.getZoom()
  if (_center && mapActivityHappened) {
    window.store.set('resqLatLng', JSON.stringify({
      lat: _center.lat(),
      lng: _center.lng(),
    }))
    window.store.set('resqZoom', '' + _zoom)
  }

  zoomLevelChanged(_zoom)
}

function updateMarkerTextVisibility(container) {
  if (_zoom > 12) {
    if (container)
      $(container).find('.mapMarkerName').show()
    else
      $('.mapMarkerName').fadeIn()
  } else {
    if (container)
      $(container).find('.mapMarkerName').hide()
    else
      $('.mapMarkerName').fadeOut()
  }
}

var mapActivityHappened = false

function mapActivity() {
  mapActivityHappened = true
}

function updateRadius() {
  if (!activeMap) return

  var bounds = activeMap.getBounds()
  if (!bounds) return

  var center = bounds.getCenter()
  var ne = bounds.getNorthEast()

  // r = radius of the earth in kilometers
  var r = 6371

  // Convert lat or lng from decimal degrees into radians (divide by 57.2958)
  var lat1 = center.lat() / 57.2958
  var lon1 = center.lng() / 57.2958
  var lat2 = ne.lat() / 57.2958
  var lon2 = ne.lng() / 57.2958

  // distance = circle radius from center to Northeast corner of bounds
  var dis = r * Math.acos(Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1))

  _radius = dis
}

function addMapListeners(newMap) {
  newMap.addListener('center_changed', mapActivity)
  newMap.addListener('zoom_changed', function () {
    mapActivity()
    updateRadius()
  })
  newMap.addListener('click', function () {
    mapActivity()
    if (openInfoWindow && openInfoWindow.isOpen()) {
      openInfoWindow.close()
      window.removeProviderIdFilter()
      openInfoWindow = null
    }
  })
}

var idleCallbackRefreshTimeout = null

function idleCallback() {
  window.logLoad('map idle')
  if (idleCallbackRefreshTimeout) return

  var now = Date.now()
  var delay = Math.max(0, window.refreshOffersPrevious + 4000 - now)
  idleCallbackRefreshTimeout = setTimeout(function () {
    idleCallbackRefreshTimeout = null
    window.refreshOffers()
  }, delay)

  window.updateNearbyProviders()
}

function setMaps() {
  var boundsLiteral, latlng, zoom

  var smallVisible = $('#smallMap').is(':visible')
  var bigVisible = $('#bigMap').is(':visible')

  if (_center && _zoom) {
    latlng = _center
    zoom = _zoom
  } else if (window.store.get('resqLatLng')) {
    latlng = JSON.parse(window.store.get('resqLatLng'))
    zoom = parseInt(window.store.get('resqZoom')) || 12
  } else {
    if (use.env && use.env.defaultMapBoundariesBasedOnIP) {
      var _b = use.env.defaultMapBoundariesBasedOnIP
      boundsLiteral = {
        south: _b.minLatitude,
        north: _b.maxLatitude,
        west: _b.minLongitude,
        east: _b.maxLongitude
      }
    } else {
      latlng = {lat: 60.175, lng: 24.95}
    }
    zoom = 5
  }

  // Map styles for the app:
  // - transit markers removed
  // - points of interest removed (to avoid confusing them with ResQ markers)
  var styles = [
    {
      "featureType": "poi",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    }
  ]

  var mapOptions = {
    center: latlng,
    zoom: zoom,
    streetViewControl: false,
    mapTypeControl: false,
    styles: styles,
    fullscreenControl: false
  }

  if (bigVisible) {
    $('#mainScroller .goToMyLocationButton').removeClass('narrowView') // hack

    if (bigMap) {
      if (activeMap != bigMap) {
        window.google.maps.event.trigger(bigMap, 'resize')
        if (!boundsLiteral) {
          bigMap.setCenter(latlng)
          bigMap.setZoom(zoom)
        }
      }
    } else {
      bigMap = new window.google.maps.Map(document.getElementById('bigMap'), mapOptions)
      bigMap.addListener('idle', function () {
        if (activeMap == bigMap) {
          if ($('#bigMap').is(':visible')) updateCenter()
          else setMaps()
        }
        idleCallback()
      })
      addMapListeners(bigMap)
    }
    activeMap = bigMap
  } else if (smallVisible) {
    $('#mainScroller .goToMyLocationButton').addClass('narrowView') // hack

    if (smallMap) {
      if (activeMap != smallMap) {
        window.google.maps.event.trigger(smallMap, 'resize')
        if (!boundsLiteral) {
          smallMap.setCenter(latlng)
          smallMap.setZoom(zoom)
        }
      }
    } else {
      smallMap = new window.google.maps.Map(document.getElementById('smallMap'), mapOptions)
      smallMap.addListener('idle', function () {
        if (activeMap == smallMap) {
          if ($('#smallMap').is(':visible')) updateCenter()
          else setMaps()
        }
        idleCallback()
      })
      addMapListeners(smallMap)
    }
    activeMap = smallMap
  }

  if (boundsLiteral) {
    activeMap.fitBounds(boundsLiteral)
  }

  moveMarkersToCurrentMap()

  updateRadius()
}

wait.googleMaps.then(function () {
  window.logLoad('initMap')

  window.MapMarker.init()
  geocoder = new window.google.maps.Geocoder()

  wait.env.then(setMaps)

  locationMarker = new window.google.maps.Marker({
    clickable: false,
    icon: new window.google.maps.MarkerImage('/app/img/icon_mylocation.png',
      new window.google.maps.Size(100, 100),
      new window.google.maps.Point(0, 0),
      new window.google.maps.Point(10, 10),
      new window.google.maps.Size(20, 20)),
    shadow: null,
    zIndex: 999,
    map: activeMap

  })
})

window.addEventListener('load', function () {
  window.logLoad('window.load event')
})

// called by google maps js
window.googleMapsReceived = function () {
  waitNoMore.googleMaps()
}

function startProviderLocationEffect(provider) {
  for (var pId in window.providerManager.providerMarkers) {
    if (window.providerManager.providerMarkers[pId].provider.id === provider.id) {
      $(window.providerManager.providerMarkers[pId].element).find('.mapMarker').addClass('providerLocationEffect')
      break
    }
  }
}

function endProviderLocationEffect() {
  $('.providerLocationEffect').removeClass('providerLocationEffect')
}

function showSmallMap() {
  $('#smallMap').css('height', '')
  $('#smallMapContainer').show()
}

function hideSmallMap() {
  $('#smallMap').css('height', '0')
  $('#smallMapContainer').hide()
}
; /* START FILE app/js/mapMarker.js */ // Based on http://humaan.com/custom-html-markers-google-maps/

function MapMarker(latlng, map, provider) {
    this.latlng = new window.google.maps.LatLng(latlng)
    this.provider = provider
    this.setMap(map)
}

MapMarker.init = function() {
    MapMarker.prototype = new window.google.maps.OverlayView()
    MapMarker.prototype.draw = function() {
		
        var self = this
		
        var div = this.div
		
        if (!div) {
            div = this.div = $('<div>').addClass('mapMarkerContainer').css({
                position: 'absolute',
            }).attr('id', 'MapMarker_' + (''+Math.random()).substr(8))

            var mapMarker = $('<div>').addClass('mapMarker').appendTo(div)

            $('<img>').addClass('mapMarkerIcon').attr({ src: self.provider.favourite ? 'img/pin_fav_green.png' : 'img/pin.png' }).appendTo(mapMarker)
            $('<div>').addClass('mapMarkerName').text(self.provider.name).appendTo(mapMarker)

            if (self.provider.offers.length == 0) {
                mapMarker.addClass('noOffers')
            } else {
                var unitsLeft = self.provider.unitsLeft
                var quantityDiv = $('<div>').addClass('mapMarkerQuantity').text(unitsLeft).appendTo(mapMarker)
                if (unitsLeft >= 100)
                    quantityDiv.addClass('mapMarkerQuantityBigNumber')
            }


            mapMarker.children().hover(function() {
                mapMarker.addClass('mapMarkerHover')
            }, function() {
                mapMarker.removeClass('mapMarkerHover')
            }).click(function(event) {
                // DO NOT CLICK MAP!!!!!
                if (event.stop)
                    event.stop()
                event.cancelBubble = true
                if (event.stopPropagation) {
                    event.stopPropagation()
                }
                if (event.preventDefault) {
                    event.preventDefault() 
                } else {
                    event.returnValue = false  
                }

                window.google.maps.event.trigger(self, 'click')
                return false
            })

            window.updateMarkerTextVisibility(mapMarker)

            var divElem = div[0]
            var panes = this.getPanes()
            panes.overlayImage.appendChild(divElem)
        }
		
        var point = this.getProjection().fromLatLngToDivPixel(this.latlng)
		
        if (point) {
            div.css({
                left: point.x + 'px',
                top: point.y + 'px',
            })
        }
    }

    MapMarker.prototype.remove = function() {
        if (this.div) {
            this.div.remove()
            this.div = null
        }	
    }

    MapMarker.prototype.getPosition = function() {
        return this.latlng	
    }
}
; /* START FILE app/js/view/abstractView.js */ 
var abstractViewPrototype = {
    parent: null,
    content: null,
    backButtonName: 'Back',
    refreshOffers: null,

    show: function() {
        if (!this.parent && this !== window.rootView)
            this.parent = window.rootView
        var self = this
        currentView = this
        $('#mainScroller').scrollTop(0)
        var backButton = $('#backButton').empty()
        $('#frontButton').empty()
        if (this.parent) {
            backButton.append(window.createTextButton(this.parent.backButtonName, function() {
                self.parent.show()

                if (self._backButtonOpensMenu) {
                    $('#profileButton').click()
                }
            }))
            $('#profileButton').hide()
            $('#searchButton').hide()
        } else {
            $('#profileButton').show()
            $('#searchButton').show()
        }

        window.hideSmallMap()
        this.content = $('#mainContent').empty()
        this.content.parent().removeAttr('viewType')
        this.content.parent().removeAttr('view')
        this.build()
    },
}
var currentView = null
; /* START FILE app/js/view/offersView.js */ function OffersView(parent) {
    this.name = 'OffersView'
    this.parent = parent
    this.backButtonName = lang.view.offers

    var resultsCache = ''

    var titleText = lang.offers.titleText.replace('\n', '<br/>')

    var offerList = new window.OfferList()

    this.build = function() {
        window.showSmallMap()

        resultsCache = ''

        this.content.empty()
        this.content.append(window.createInfoArea(titleText, 'hideIfSmallScreen'))
        // this.content.append(offerList.el);
        window.redom.mount(this.content[0], offerList)

        window.eventManager.listen('offersUpdated', buildOffers)
        window.eventManager.listen('searchParametersUpdated', buildOffers)

        buildOffers()

        this.refreshOffers()
    }

    function buildOffers() {
        offerList.update(window.providerManager.offers, window.searchParametersManager.searchParameters)
        window.logLoad('end of offers view')
    }

    this.refreshOffers = function(callback) {
        var self = this

        if (!window._radius) {
            window.updateRadius()
            if (!window._radius) {
                setTimeout(function() {
                    self.refreshOffers(callback)
                }, 100)
                return
            }
        }

        if (callback) {
            callback()
        }
    }
}

OffersView.prototype = window.abstractViewPrototype
; /* START FILE app/js/view/settingsView.js */ function SettingsView(parent) {
    this.parent = parent
    var self = this

    this.backButtonName = lang.view.settings

    this.build = function() {
        window.endProviderLocationEffect()

        this.content.empty()
        this.content.parent().attr('viewType', 'settings')

        SettingsView.createHeader(lang.menu.settings, '/app/img/settings/icon_settings.png').appendTo(this.content)
        var settings = SettingsView.createSection().appendTo(this.content)

        function createSettingsButton(text, viewClass, iconUrl) {
            window.createNavigationButton(text, function() {
                new viewClass(self, self).show()
            }, iconUrl).appendTo(settings)
        }

        createSettingsButton(lang.settings.account.myInfo, window.SettingsMyInfoView, '/app/img/settings/icon_my_info.png')
        createSettingsButton(lang.settings.account.changeLanguage, window.SettingsLanguageView, '/app/img/settings/icon_language.png')
    }
}
SettingsView.prototype = window.abstractViewPrototype

SettingsView.createHeader = function(text, iconUrl) {
    var div = $('<div>').addClass('appSettingsHeader')
    var content = $('<div>').text(text).addClass('appSettingsHeaderContent')
    if (iconUrl)
        content.prepend($('<img>').attr('src', iconUrl).addClass('appSettingsHeaderIcon'))
    div.append(content)
    return div
}
SettingsView.createSection = function(titleText, iconUrl) {
    var div = $('<div>').addClass('settingsSection settingsSidePadding')
    if (titleText) {
        var title = $('<div>').text(titleText).addClass('settingsSectionTitle')
        if (iconUrl)
            title.prepend($('<img>').attr('src', iconUrl).addClass('settingsSectionTitleIcon'))

        div.append(title)
    }
    return div
}
; /* START FILE app/js/view/settingsLanguageView.js */ function SettingsLanguageView(parent, viewAfterDetailsEntered) {
    this.parent = parent
    var self = this
	
    this.build = function() {
        this.content.empty()
        this.content.parent().attr('viewType', 'settings')

        window.SettingsView.createHeader(lang.settings.account.changeLanguage, '/app/img/settings/icon_language.png').appendTo(this.content)

        var langSettings = window.SettingsView.createSection().appendTo(this.content).addClass('dietSettings')
		
        var langItems = use.env.SUPPORTED_LANGUAGES_WITH_NAMES.sort(function(a, b) { return a.name > b.name }).map(function(lang) {
            return {
                value: lang.id,
                text: lang.name
            }
        })
		
        var selectedLanguage = window.getLanguage()

        langItems.forEach(function(langItem) {
            var button = window.createNavigationButton(langItem.text, function() {
                window.setLanguageAndReload(langItem.value)
            }).appendTo(langSettings)
            button.find('img').remove()
            if (langItem.value === selectedLanguage)
                button.css('font-weight', 'bold')
        })

    }
}
SettingsLanguageView.prototype = window.abstractViewPrototype
; /* START FILE app/js/view/settingsPasswordView.js */ function SettingsPasswordView(parent, viewAfterPasswordEntered) {
	this.parent = parent
	var self = this


	this.build = function() {
		window.endProviderLocationEffect()
		
		this.content.empty()
		this.content.parent().attr('viewType', 'settings')

		window.SettingsView.createHeader(lang.settings.changePassword.title, '/app/img/settings/icon_password.png').appendTo(this.content)
		var passwordSettings = window.SettingsView.createSection().appendTo(this.content)
		

		var oldPasswordBlock = window.createInputBlockOld('password', '', lang.settings.changePassword.currentPass.placeholder, 'password', '')
		var passwordBlock = window.createInputBlockOld('password', '', lang.settings.changePassword.newPass.placeholder, 'password', '')
		//var password2Block = createInputBlockOld("password2", "", lang.settings.changePassword.newPass.placeholder, "password", "");

		var button = window.createBasicButton(lang.settings.changePassword.save, function() {
			var pass1 = passwordBlock.getValueFunc()
			//var pass2 = password2Block.getValueFunc();

			/*
			if (pass1 != pass2) {
				alert(lang.settings.changePassword.mistypedNewPassword);
				return;
			}
			*/

			var data = {
				oldPassword: oldPasswordBlock.getValueFunc(),
				newPassword: pass1
			}

			if (!data.oldPassword || !data.newPassword) {
				alert(lang.settings.changePassword.noPasswordInserted)
				return
			}

			passwordSettings.find('*').prop('disabled', true)

			window.postRequest('app/changePassword', data).done(function(results) {
				results = JSON.parse(results)
				window.store.set('userToken', results.userToken)
				alert(results.message)

				passwordSettings.find('*').prop('disabled', false)
				passwordSettings.find('input').val('')

				if (viewAfterPasswordEntered)
					viewAfterPasswordEntered.show()
			}).fail(function(results) {
				alert(results.responseText)
				passwordSettings.find('*').prop('disabled', false)
				passwordSettings.find('input').val('')
			})
		}, 'basicConfirmButton').width('100%')

		passwordSettings.append([oldPasswordBlock, passwordBlock, button])
	}
}
SettingsPasswordView.prototype = window.abstractViewPrototype
; /* START FILE app/js/view/settingsMyInfoView.js */ function SettingsMyInfoView(parent, viewAfterSaved) {
	this.parent = parent
	var self = this

	this.build = function() {

		window.endProviderLocationEffect()

		this.content.empty()
		this.content.parent().attr('viewType', 'settings')

		window.SettingsView.createHeader(lang.settings.account.myInfo, '/app/img/settings/icon_my_info.png').appendTo(this.content)

		var passwordSection = window.SettingsView.createSection().appendTo(this.content)
		var changePasswordButton = window.createNavigationButton(lang.settings.account.changePassword, function() {
			new window.SettingsPasswordView(self, self).show()
		}, '/app/img/settings/icon_password.png').width('100%').addClass('myInfoSettings-changePasswordButton')
		passwordSection.append(changePasswordButton)

		var myInfo = $('<div>').appendTo(this.content).addClass('myInfoSettings-myInfo settingsSidePadding')

		var email = window.createSimpleInputBlock(lang.settings.myInfo.email, 'text', window.myProfile.email)
		var firstName = window.createSimpleInputBlock(lang.settings.myInfo.firstName, 'text', window.myProfile.firstName)
		var lastName = window.createSimpleInputBlock(lang.settings.myInfo.lastName, 'text', window.myProfile.lastName)
		//var country = createSimpleInputBlock(lang.settings.myInfo.country, "text", myProfile.country);
		var phoneNumber = window.createSimpleInputBlock(lang.settings.myInfo.phoneNumber, 'text', window.myProfile.phoneNumber)
		//var country = createSimpleInputBlock(lang.settings.myInfo.country, 'select', myProfile.country)

		var countries = Object.keys(use.env.COUNTRIES)

		var ret = {labels: [], values: []}

		// Sort by english name
		countries.sort(function(a, b) {
			var A, B
			A = use.env.COUNTRIES[a].nameInEnglish.toLowerCase()
			B = use.env.COUNTRIES[b].nameInEnglish.toLowerCase()
			if (A > B) {
				return 1
			} else {
				return -1
			}
		})

		for (var i = 0; i < countries.length; i++) {
			ret.values.push(use.env.COUNTRIES[countries[i]].idShort.toUpperCase())
			ret.labels.push(use.env.COUNTRIES[countries[i]].nameInEnglish)
		}

		// If our current country is set to something else than the countries w
		if (window.myProfile.country && ret.values.indexOf(window.myProfile.country.toUpperCase()) < 0) {
			ret.values.unshift(window.myProfile.country.toUpperCase())
			ret.labels.unshift(window.myProfile.country.toUpperCase())
		}

		// Add entry for "No country"; it can be changed to a real country,
		// but once that's done you can't go back.
		var myCountry = window.myProfile.country
		if (!window.myProfile.country) {
			ret.values.unshift(null)
			ret.labels.unshift('')
			myCountry = null
		}

		// API requires us to provide placeholder even it it's not applicable. Nice!
		const unusedPlaceholder = '...'
		var country = window.createInputBlockOld('country', lang.settings.myInfo.country.title,
			unusedPlaceholder, 'select', myCountry, null, null, {
			labels: ret.labels,
			values: ret.values
		})

		var button = window.createBasicButton(lang.settings.myInfo.submit, function() {
			if (window.myProfile.email && !email.getValueFunc()) {
				return window.showAlert(lang.error.cantRemoveEmail)
			}

			var p = Promise.resolve()

			p = p.then(function(result) {

				var data = {}
				function add(handle, name) {
					if (handle.getValueFunc.changed)
						data[name] = handle.getValueFunc()
				}
				add(email, 'email')
				add(firstName, 'firstName')
				add(lastName, 'lastName')
				add(phoneNumber, 'phoneNumber')
				add(country, 'country')

				if ($.isEmptyObject(data)) {
					if (viewAfterSaved) {
						viewAfterSaved.show()
					}
					return
				}

				window.postRequest('app/editUser', data).done(function(response) {
					$.extend(window.myProfile, data)
					response = JSON.parse(response)

					if (response.userToken) {
						window.store.set('userToken', response.userToken)
					}

					window.updateMyProfile()
					alert(response.message)
					if (viewAfterSaved) {
						viewAfterSaved.show()
					}
				}).fail(window.dialogFailResponse)

			})

		}, 'basicConfirmButton').width('100%')

		myInfo.append([
			email,
			firstName,
			lastName,
			phoneNumber,
			country,
			button
		])
	}
}
SettingsMyInfoView.prototype = window.abstractViewPrototype
; /* START FILE app/js/view/offerDetailsView.js */ function OfferDetailsView(parent, offer) {
    wait.FBAppEvents.then(function(AppEvents) {
        var params = {}
        params[AppEvents.ParameterNames.CONTENT_ID] = offer.id
        params[AppEvents.ParameterNames.CURRENCY] = window.offerToCurrencyUpperCase(offer)
        AppEvents.logEvent(AppEvents.EventNames.VIEWED_CONTENT, window.offerPriceToFloat(offer), params)
    })

    this.parent = parent
    var self = this
    this.backButtonName = lang.view.offerDetails

    var cache = ''

    this.build = function() {
        cache = ''
        this._buildView()
        this._addShareButton()
    }

    var APP_OFFER_URL_PREFIX = 'https://app.resq-club.com/offer/'

    this._addShareButton = function() {
        // Works on desktop browsers, not on iPhone - this probably works well
        var isAutomaticCopySupported = !window.isTouch

        var shareButton = $('#frontButton.shareButton')
        var shareTextButton = window.createTextButton(lang.offer.button.share, function() {
            var shareDialog = new window.ModalDialog('', {
                class: 'shareDialog',
                autoTabIndexify: 1
            })
            var shareUrl = APP_OFFER_URL_PREFIX + offer.id
            var urlInput = shareDialog.addInput({
                type: 'text',
                value: shareUrl
            })
            var actualInput = urlInput.find('input')
            actualInput.attr('id', 'clipboardTarget')
            if (isAutomaticCopySupported) {
                actualInput.attr('readonly', true)
            }
            actualInput.addClass('urlToCopy')
            function selectUrl() {
                actualInput.select()
            }

            if (isAutomaticCopySupported) {
                actualInput.click(selectUrl)
            }

            if (isAutomaticCopySupported) {
                shareDialog.addButton(lang.offer.share.button.copyLink, function() {
                    var inputValue = actualInput.val()
                    window.clipboard.copy(inputValue)
                    shareDialog.enableAllAgain()
                    selectUrl()
                })
            }

            shareDialog.show()
            if (isAutomaticCopySupported) {
                selectUrl()
            }
        }).addClass('shareButton')

        shareButton.append(shareTextButton)
    }

    this._buildView = function() {
        this.content.empty()
        this.content.append('Offer Details')
        buildOfferDetails(this.content, offer, this)

        var buttonContainer = $('<div>').addClass('offerDetailsOrderingDiv')
        var button = window.createBasicButton(lang.offer.purchaseFromTheApp, function() {
            window.open("https://app.resq.club/gBQuqf3fNTb", '_blank')
        }, 'basicConfirmButton').css('width', '90%')

        buttonContainer.append(button)
        this.content.append(buttonContainer)
    }

    this.refreshOffers = function(callback) {
        window.getRequest('app/offer/' + offer.id).done(function(results) {
            if (results === cache) return

            cache = results

            var provider = offer.provider
            const newOffer = JSON.parse(results)
            if (newOffer.dynamicPrice <= offer.dynamicPrice) {
                offer = newOffer
            } else {
                const promisedPrice = offer.dynamicPrice
                offer = newOffer
                offer.dynamicPrice = promisedPrice
            }
            offer.provider = provider

            self._buildView()
        })
    }
}

OfferDetailsView.prototype = window.abstractViewPrototype

function buildOfferDetails(container, offer, thisView) {
    container.empty()

    var top = $('<div>').addClass('offerDetailsTop').appendTo(container)

    if (offer.imageUrl) {
        var $offerDetailsImage =
		$('<div class=offerDetailsImage>' +
		'<img src="' + offer.imageUrl + '"></img>' +
		'</div>')
        top.append($offerDetailsImage)
        $offerDetailsImage.click(function() {
            $offerDetailsImage.toggleClass('expanded')
        })
    }

    $('<div>').addClass('offerDetailsName').appendTo(top).text(offer.name)
    $('<p>').addClass('offerDetailsDescription').appendTo(top).text(offer.description)

    const price = offer.dynamicPrice
    const priceTagElement = window.createPriceTag(price, offer.provider, 'large').appendTo(top)

    if (offer.tags.some(t => t.id === 'nonsurplus')) {
        priceTagElement.addClass('nonsurplus-background')
    }

    var bottom = window.createOfferTags(offer.tags).appendTo(container)

    var providerNameDiv = $('<div>').addClass('infoRow')
    var providerName = $('<div>').addClass('offerDetailsProviderName').appendTo(providerNameDiv)

    if (thisView) {
        providerName.append(window.createTextButton(offer.provider.name, function() {
            new window.ProviderView(thisView, offer.provider).show()
        }))
    } else {
        providerName.text(offer.provider.name)
    }
    var address = $('<div>').addClass('offerDetailsAddress')
    if (offer.provider.address) {
        if (thisView) {
            address.append(window.createTextButton(offer.provider.address, function() {
                window.goToLocation(offer.provider)
            }))
        } else {
            address.append(offer.provider.address)
        }
    }
    address.appendTo(providerName)
    var fetchBeforeDiv = $('<div>').addClass('infoRow').prependTo(bottom)
    var buyBeforeDiv = $('<div>').addClass('infoRow').prependTo(bottom)

    window.createFontIcon('icon-clock').appendTo(buyBeforeDiv)
    $('<div>').addClass('offerDetailsBuyDL').appendTo(buyBeforeDiv).text(window.formatText(lang.offer.orderBefore, window.formatTime(offer.orderEnd)))

    window.createFontIcon('icon-bag').appendTo(fetchBeforeDiv)

    var fetchDLElement = $('<div>').addClass('offerDetailsFetchDL').appendTo(fetchBeforeDiv)
    if (new Date(offer.fetchStart) < new Date())
        fetchDLElement.text(window.formatText(lang.offer.pickupBefore, window.formatTime(offer.fetchEnd)))
    else
        fetchDLElement.addClass('offerDetailsFetchDLWarning').text(window.formatText(lang.offer.pickupBetween, window.formatTime(offer.fetchStart), window.formatTime(offer.fetchEnd)))

    var quantityDiv = $('<div>').addClass('infoRow').prependTo(bottom)
    window.createFontIcon('icon-portions').appendTo(quantityDiv)
    $('<div>').addClass('offerDetailsQuantity').appendTo(quantityDiv).text(window.formatText(lang.offer.portionsLeft, offer.unitsLeft))

    providerNameDiv.prependTo(bottom)
}

// Util function just to be able to code offline
window.openOffer = function(id) {
    window.getRequest('app/offer/' + id).done(function(response) {
        var offer = JSON.parse(response)
        offer.provider = {
            country: {
                currency: {
                    id: 'eur',
                    decimals: 2,
                    format: '%@',
                    unitMultiplier: 100
                }
            }
        }
        log(offer)
        new OfferDetailsView(null, offer).show()
    })
}
; /* START FILE app/js/view/providerView.js */ function ProviderView(parent, provider) {
    this.parent = parent

    var self = this
    this.backButtonName = 'Provider'

    var resultsCache = ''

    this.build = function() {
        resultsCache = ''
        this.content.empty()
        this.refreshOffers()
    }

    this.refreshOffers = function(callback) {
        var self = this
        var providerObject = window.providerManager.detailedProviders[provider.id]
        if (!window.providerManager) {
            window.rootView.show()
            return
        }

        window.providerManager.getProvider(provider.id).then(function(provider) {
            if (self != window.currentView) return

            var p = provider
            self.content.empty()

            var hero = $('<div />')
            hero.addClass('hero')

            var nameDiv = $('<div>').text(p.name).addClass('providerName').appendTo(hero)

            window.createTextButton(p.address, function() {
                window.goToLocation(p)
            }).appendTo(hero)

            if (window.myProfile) {
                // logged in, show favourite button
                hero.append([
                    '<br/>',
                    window.createFavouriteButton(p).css({
                        marginTop: '10px'
                    })
                ])
            }

            hero.css({
                textAlign: 'center',
                padding: '20px'
            })
            hero.appendTo(self.content)

            var infoDiv = $('<div>').addClass('providerInfo').appendTo(self.content)
            $('<div>').text(p.description).addClass('providerDescription').appendTo(infoDiv)

            //createFontIcon("icon-pin").appendTo(infoDiv);

            if (p.website) {
                var row = $('<div>').addClass('infoRow').append(window.createTextButton(p.website, function() {
                    var link = $('<a>').attr({
                        'href': p.website,
                        'target': '_blank',
                    }).css({display: 'block'}).text('link').appendTo($('body'))
                    link[0].click()
                    link.remove()
                    //setTimeout(function(){link[0].click();}, 1000);
                })).appendTo(infoDiv)
                row.prepend(window.createFontIcon('icon-globe'))
            }

            if (p.publicPhoneNumber) {
                var phoneNumberRow = $('<div>').addClass('infoRow').append(window.createTextButton(p.publicPhoneNumber, function() {
                    var link = $('<a>').attr({
                        'href': 'tel:' + p.publicPhoneNumber,
                        'target': '_blank',
                    }).css({display: 'block'}).text('link').appendTo($('body'))
                    link[0].click()
                    link.remove()
                    //setTimeout(function(){link[0].click();}, 1000);
                })).appendTo(infoDiv)
                // phoneNumberRow.prepend(createFontIcon('icon-globe'))
            }

            var offerDiv = $('<div>').addClass('providerOffers').appendTo(self.content)

            var offerList = new window.OfferList()
            offerList.update(p.offers)

            const removeListener = window.eventManager.listen('offersUpdated', () => {
                offerList.update(p.offers)
            })

            function removeListenerIfViewDetached() {
                const heroElement = hero[0]
                // There is no cleanup logic so we check periodically if this view is dead or not.
                // this.content remains the same across views, so we check just some element that
                // will be detached when the user goes to another view... o_@
                const viewIsStillAlive = document.body.contains(heroElement)

                if (viewIsStillAlive) {
                    setTimeout(removeListenerIfViewDetached, 1000)
                } else {
                    removeListener()
                }
            }

            removeListenerIfViewDetached()

            offerDiv.append(offerList.el)

            if (callback)
                callback()
        })
    }
}
ProviderView.prototype = window.abstractViewPrototype
; /* START FILE app/js/view/myOrdersView.js */ function MyOrdersView(parent) {
    this.parent = parent
    var self = this

    this.build = function() {
        window.endProviderLocationEffect()

        if (window.myProfile.fullName) {
            var titleText = window
                .formatText(lang.orders.titleText, window.myProfile.fullName || '')
                .replace('\n', '<br/>')
            this.content.append(window.createInfoArea(titleText))
        }

        window.getRequest('app/orders').done(function(results) {
            results = JSON.parse(results)

            for (var p = results.orders.length - 1; p >= 0; p--) {
                createOrderRow(results.orders[p], self).appendTo(self.content)
            }
        })
    }
}
MyOrdersView.prototype = window.abstractViewPrototype

function createOrderRow(order, selfView) {
    var orderRow = $('<div>')
        .addClass('offerRow')
        .attr('providerId', order.provider.id)
    if (window.isOrderCancelled(order)) {
        orderRow.addClass('cancelledOrder')
    }
    var div = $('<div>').addClass('offerRow-content')
    orderRow.append(div)

    function containsNonsurplusItems(order) {
        const { orderItems } = order
        return orderItems.some(oi => {
            if (!oi.offer) {
                return false
            }

            // Some orderItems (such as payment method costs) have .offer but they do not have tags
            if (!Array.isArray(oi.offer.tagIds)) {
                return false;
            }

            return oi.offer.tagIds.includes('nonsurplus')
        })
    }

    var price = window.createPriceTag(order.priceAfterRefunds, order.provider).appendTo(div)
    if (containsNonsurplusItems(order)) {
        price.addClass('nonsurplus-background')
    }
    var name = $('<div>')
        .addClass('offerRowName')
        .appendTo(div)
    name.attr('data-order-id', order.id)

    var offerItems = order.orderItems.filter(function(oi) {
        return oi.type === 'offer'
    })
    for (var i = 0; i < offerItems.length; i++) {
        var offerItem = offerItems[i]
        var offerItemText = offerItem.quantity + ' × ' + offerItem.offer.name
        if (offerItem.quantity === 1 && offerItems.length === 1) {
            offerItemText = offerItem.offer.name
        }
        var offerItemDiv = $('<div>').text(offerItemText)

        if (offerItem.refunded) {
            offerItemDiv.addClass('orderItemCancelled')
        }

        name.append(offerItemDiv)
    }

    var details = $('<div>')
    details.addClass('offerRow-details')

    var providerIcon = window
        .createFontIcon(order.provider.favourite ? 'icon-hat' : 'icon-hat')
        .appendTo(details)
    providerIcon.addClass('green')

    var providerName = $('<div>')
        .addClass('offerRowProviderName')
        .appendTo(details)
    providerName.text(order.provider.name)

    details.append('<div class="spacer" />')

    $('<span class="icon-clock"></span> ')
        .addClass('grayEffect')
        .appendTo(details)
    $('<span>' + window.formatDateTime(order.timestamp) + '&nbsp;</span>')
        .appendTo(details)
        .addClass('grayEffect')

    var portionCount = $('<div />')
    portionCount.addClass('portion-count')

    var itemCount = offerItems
        .filter(oi => !oi.refunded)
        .reduce((sum, oi) => sum + oi.quantity, 0)

    if (itemCount !== 0) {
        $('<span class="icon-portions"></span>')
            .addClass('grayEffect')
            .appendTo(portionCount)
        $('<span>' + itemCount + '</span>')
            .appendTo(portionCount)
            .addClass('grayEffect')
    }

    portionCount.appendTo(price)

    details.appendTo(div)

    div.click(function(e) {
        new window.OrderDetailsView(selfView, order).show()
    })

    return orderRow
}
; /* START FILE app/js/view/orderDetailsView.js */ function OrderDetailsView(parent, order) {
    this.parent = parent

    this.build = function() {
        var topInfo = $('<div>')
            .addClass('orderDetails-topInfo')
            .appendTo(this.content)
        topInfo.append([
            $('<span>')
                .addClass('orderDetails-topInfoReceipt')
                .text(lang.orderDetails.title),
            $('<span>')
                .addClass('orderDetails-topInfoTimestamp')
                .text(window.formatDateTime(order.timestamp)),
        ])

        var orderInfo = $('<div>')
            .addClass('orderDetails-orderInfo flexboxSupport')
            .appendTo(this.content)

        var name = $('<div>')
            .addClass('orderDetails-orderInfoName')
            .appendTo(orderInfo)

        var offerItems = order.orderItems.filter(function(oi) {
            return oi.type === 'offer'
        })
        for (var i = 0; i < offerItems.length; i++) {
            var offerItem = offerItems[i]
            var offerItemText = offerItem.quantity + ' × ' + offerItem.offer.name
            if (offerItem.quantity === 1 && offerItems.length === 1) {
                offerItemText = offerItem.offer.name
            }

            var offerItemDiv = $('<div>').text(offerItemText)

            if (offerItem.refunded) {
                offerItemDiv.addClass('orderItemCancelled')
            }

            name.append(offerItemDiv)
        }

        var priceWrapper = $('<div />')
            .addClass('orderDetails-priceWrapper')
            .appendTo(this.content)
        var priceTag = window
            .createPriceTag(order.priceAfterRefunds, order.provider, 'large')
            .addClass('orderDetails-orderInfoPrice')
            .appendTo(priceWrapper)

        if (offerItems.some(oi => oi.offer.tags.includes('nonsurplus'))) {
            priceTag.addClass('nonsurplus-background')
        }

        if (window.isOrderCancelled(order)) {
            name.addClass('cancelledOrder')
            priceTag.addClass('cancelledOrder')
        }

        var descriptionSection = window.createOfferTags([]).appendTo(this.content)

        function createButtonTextSection(primary, secondary) {
            var section = [
                $('<div>')
                    .addClass('orderDetails-buttonTextSectionPrimary')
                    .text(primary),
            ]
            if (secondary)
                section.push(
                    $('<div>')
                        .addClass('orderDetails-buttonTextSectionSecondary')
                        .text(secondary)
                )
            return section
        }

        var moreInfoSection = $('<div>')
            .addClass('orderDetails-moreInfoSection')
            .appendTo(this.content)

        if (new Date(order.fetchEnd) > new Date()) {
            var pickUpSection = $('<div>')
                .addClass('orderDetails-pickUpInfo')
                .appendTo(moreInfoSection)
            pickUpSection.append([
                $('<img>')
                    .attr('src', '/app/img/Icons_clock.png')
                    .addClass('navigationButtonIcon'),
                $('<div>')
                    .addClass('navigationButtonText')
                    .append(
                        createButtonTextSection(
                            window.formatText(
                                lang.orderDetails.pickupBefore,
                                window.formatTime(order.fetchEnd)
                            ),
                            lang.orderDetails.pickupInfo
                        )
                    ),
            ])
        }

        var providerNameDiv = $('<div>').addClass('infoRow')

        var providerName = $('<div>')
            .addClass('offerDetailsProviderName')
            .appendTo(providerNameDiv)
        providerName.text(order.provider.name)

        var address = $('<div>').addClass('offerDetailsAddress')
        if (order.provider.address) {
            address.append(order.provider.address)
        }
        address.appendTo(providerName)

        providerNameDiv.appendTo(descriptionSection)
    }
}

OrderDetailsView.prototype = window.abstractViewPrototype
; /* START FILE app/js/helpPopups.js */ function openFirstTimePopup(callback) {
    var dlg = new window.ModalDialog(lang.registered.title, {
        width: '500px',
        hideCallback: callback
    })
    dlg.add(lang.registered.body)
    dlg.addButton('Ok', function() {
        dlg.hide() // will call the goToMyLocation (cancel)
    })
    dlg.show()
}

function openAllowLocationPopup(callback) {
    var dlg = new window.ModalDialog(lang.whereAreYou.title, {
        width: '500px',
        hideCallback: callback
    })
    dlg.add($('<p>').text(lang.whereAreYou.body))

    var locationBlock = window.createSimpleInputBlock(lang.whereAreYou.locationInput.label, 'text')

    dlg.add(locationBlock)

    dlg.addButton('Ok', function() {
        if (findFunc) findFunc()
        dlg.hide() // will call the goToMyLocation (cancel)
    })
    dlg.show()

    var findFunc = window.createLocationAutocomplete(locationBlock.input[0], function(place) {
        var loc = place.geometry.location
        window.goToLocation({
            latitude: loc.lat(),
            longitude: loc.lng(),
        }, 15)

        window.sendInfo(loc.lat(), loc.lng())

        dlg.hide()
    })
}
; /* START FILE app/js/filter.js */ 
var myNotificationSettings = null
try {
    myNotificationSettings = JSON.parse(window.store.get('myNotificationSettings'))
} catch (e) {}
function updateNotificationSettings(doneCallback) {
    window.getRequest('app/notificationSettings').done(function(results) {
        myNotificationSettings = JSON.parse(results)
        window.store.set('myNotificationSettings', JSON.stringify(myNotificationSettings))
        if (window.updateOffers)
            window.updateOffers()
        if (typeof doneCallback == 'function')
            doneCallback()
    })
}

var refreshOffersPrevious = 0
function refreshOffers() {
    if (window.currentView && window.currentView.refreshOffers) {
        refreshOffersPrevious = Date.now()
        var scroll = $('#mainScroller').scrollTop()
        window.currentView.refreshOffers(function() {
            $('#mainScroller').scrollTop(scroll)
        })
    }
    if (window.currentView != window.rootView)
        window.rootView.refreshOffers()
}
; /* START FILE app/js/menu.js */ var myProfile = null
var menuLogo = null

function updateMyProfile(callback) {
	function createCentered(text, fontSize, topMargin, bottomMargin) {
		topMargin = topMargin || '0'
		bottomMargin = bottomMargin || '0'
		fontSize = fontSize || '14px'
		return $('<div>').addClass('profileInformationDiv').text(text).css({
			textAlign: 'center',
			fontSize: fontSize,
			marginTop: topMargin,
			marginBottom: bottomMargin,
			color: '#ffffff',
		})
	}

	function profileReceived(profile) {
		myProfile = profile
		waitNoMore.profile(myProfile)

		if (myProfile.codes)
			myProfile.codeTypes = window.fromArrayToObjectSet(myProfile.codes.map(function(c) {
				return c.type
			}))

		myProfile.favouriteProviders = window.fromArrayToObjectSet(myProfile.favouriteProviders)
		myProfile.blockedProviders = window.fromArrayToObjectSet(myProfile.blockedProviders)

		$('#menu .profileInformationDiv').remove()

		$('#menu').prepend(createCentered(myProfile.email, '16px', '0', '5px'))
		if (myProfile.id <= 100) {
			$('#menu').prepend(createCentered('#' + myProfile.id, '18px', '6px', '5px'))
		}

		if (myProfile.fullName)
			$('#menu').prepend(createCentered(myProfile.fullName, '20px'))

		if (!menuLogo) {
			menuLogo = $('<img src="/common/img/resq_q_yellow_centered.svg" />')
			menuLogo.css({
				position: 'relative',
				paddingLeft: 22,
				paddingRight: 22,
				width: '100%',
				marginTop: '-24%'
			})
		}
		menuLogo.remove()
		$('#menu').prepend(menuLogo)

		if (callback)
			callback()
	}

	window.getRequest('app/profile').done(function(results) {
		var profile = JSON.parse(results).profile

		if (profile.acceptedTermsOfUseVersion !== use.env.TERMS_OF_USE_VERSION) {
			window.askToAcceptTermsOfUse(function() {
				profileReceived(profile)
			}, false, logout)
		} else {
			profileReceived(profile)
		}
	})
}

function login(callback) {
	var menu = $('#menu').empty()

	$('#profileButton').empty().append($('<img>').attr('src', '/common/img/burger_icon.svg'))
	$('#searchButton').empty().append($('<img>').attr('src', '/common/img/search_icon.svg'))

	menu.append(window.createMenuButton(lang.menu.myOrders, function() {
		$('#profileButton').click()
		var mow = new window.MyOrdersView(window.rootView)
		if (use.env.DEV_ENV) {
			mow._backButtonOpensMenu = true
		}
		mow.show()
	}, true, null, 'icon-bag'))
	menu.append(window.createMenuButton(lang.menu.settings, function() {
		$('#profileButton').click()
		var sw = new window.SettingsView(window.rootView)
		if (use.env.DEV_ENV) {
			sw._backButtonOpensMenu = true
		}
		sw.show()
	}, true, null, 'icon-settings'))
	menu.append(window.createMenuButton(lang.menu.instructions, {
		href: 'https://help.resq-club.com/',
		target: '_blank'
	}, true, null, 'icon-instructions'))
	menu.append(window.createMenuButton(lang.menu.terms, {
		href: '../terms',
		target: '_blank'
	}, true, null, 'icon-terms'))

	menu.append(window.createMenuButton(lang.menu.logOut, function() {
		$('#profileButton').click()
		setTimeout(logout, 500)
	}, false, null, 'icon-logout'))

	var currentLanguage = window.lang.meta.language
	updateMyProfile(function() {
		if (currentLanguage && window.myProfile && window.myProfile.language && window.myProfile.language !== currentLanguage) {
			window.setLanguageAndReload(window.myProfile.language)
		}
		(callback || window.goToCachedLocation)()
	})
	window.updateNotificationSettings()

	// Enter code after login
	var codeToEnter = window.store.get('codeToSetAfterLogin')
	if (codeToEnter) {
		var codeToEnterExpiration = new Date(window.store.get('codeToSetAfterLoginExpiration'))
		if (new Date() < codeToEnterExpiration) {
			window.store.remove('codeToSetAfterLogin')
			window.store.remove('codeToSetAfterLoginExpiration')
			new window.SettingsCodeView(null, { predefinedCode: codeToEnter }).show()
		}
	}
}

function logout() {
	window.postRequest('app/logout', {}).done(function() {
		window.store.remove('userToken')
		window.store.remove('myNotificationSettings')
		window.myProfile = null

		var menu = $('#menu').empty()

		var form = $('<form>')
			.addClass('appLoginForm')
			.appendTo(menu)

		$('#profileButton')
			.empty()
			.append($('<img>').attr('src', 'img/icon_profile.png'))

		var emailBlock = window.createInputBlockOld(
			'email',
			lang.login.email.placeholder,
			'',
			'email',
			''
		)
		emailBlock.appendTo(form)
		var passwordBlock = window.createInputBlockOld(
			'password',
			lang.login.password.placeholder,
			'',
			'password',
			''
		)
		passwordBlock.appendTo(form)

		var submit = window
			.createBasicButton(
				lang.login.login,
				function() {
					var data = {
						email: emailBlock.getValueFunc(),
						password: passwordBlock.getValueFunc(),
					}
					window
						.postRequest('app/login', data)
						.done(function(results) {
							$('#profileButton').click()

							results = JSON.parse(results)
							window.store.set('userToken', results.userToken)

							var location
							var latLng = window.store.get('resqLatLng')
							try {
								if (latLng) {
									location = JSON.parse(latLng)
								}
							} catch (e) {}

							if (location) {
								window.sendInfo(location.lat, location.lng)
								login()
							} else {
								window.sendInfo()
								login()
							}
						})
						.fail(function(results) {
							alert(results.responseText)
						})
				},
				'basicConfirmButton'
			)
			.appendTo(form)

		form.submit(function(e) {
			e.preventDefault()
			submit.click()
		})

		var links = $('<div>')
			.addClass('appLoginLinks')
			.appendTo(form)
		links.append(
			window.createTextButton(lang.login.forgotPassword, function() {
				window
					.showPrompt(lang.login.resetPassword.oops.pleaseEnterYourEmail)
					.then(function(email) {
						if (email) {
							const langCode = lang.meta.language
							// The normal methods of setting the language may not work when the user is
							// not logged in (or when cookies and URL disagree, which might have been
							// the reason when testing this), so we use an inconventional one.
							// This is probably the only place where an API request uses both query
							// parameters and body parameters.
							window
								.postRequest('app/sendPasswordChangeLinkToEmail?lang=' + langCode, {
									email: email,
								})
								.done(function() {
									window.showAlert(lang.login.resetRequested.message, '')
								})
								.fail(function(e) {
									window.showAlert(e.responseText)
								})
						}
					})
			})
		)

		if (use.env.DEV_ENV) {
			var newUserButton = window.createBasicButton(
				lang.registration.title,
				function() {
					var dlg = new window.ModalDialog(lang.registration.title, {
						autoTabIndexify: true,
						autofocusFirstInput: true,
					})

					var emailValue = emailBlock.getValueFunc()
					var emailInput = dlg
						.addInput({
							name: 'email',
							placeholder: lang.registration.email.placeholder,
							value: emailValue,
						})
						.css({ marginTop: 31 })

					var passwordInput = dlg.addInput({
						name: 'password',
						type: 'password',
						placeholder: lang.registration.password.placeholder,
					})

					setTimeout(function() {
						if (emailInput) {
							passwordInput.data('input').focus()
						} else {
							emailInput.data('input').focus()
						}
					}, 50)

					dlg.addButton(lang.registration.submit, function(data) {
						window
							.postRequest('app/registerNewUser', data)
							.done(function(results) {
								window.ga && window.ga('send', 'event', 'Customer Signup', 'submit')
								results = JSON.parse(results)

								window.store.set('userToken', results.userToken)
								window.store.set('showFirstTimeInfo', true)

								window.redirect('/app')
							})
							.fail(function(response) {
								window.dialogFailResponse(response)
							})
					})

					window.askToAcceptTermsOfUse(function() {
						dlg.show()
					}, true)
				},
				'basicConfirmButton'
			)

			menu.append(newUserButton)
		}
	})
}
; /* START FILE app/js/util.js */ function updateTags() {
    window.getRequest('app/tags').done(function(response) {
        window.tags = {}
        try {
            var tagList = JSON.parse(response).tags
            for (var i = 0; i < tagList.length; i++) {
                window.tags[tagList[i].id] = tagList[i]
            }
        } catch (e) {
            console.log('failed to parse tags', e)
        }
    }).fail(function(err) {
        console.log('failed to get tags', err)
    })
}

// TODO join with similar one on the other side!
function sendInfo(lat, lng) {
    function getOSName() {
        var result = 'Unknown OS'
        var appVersion = navigator.appVersion
        if (appVersion.indexOf('Win') != -1) result = 'Windows'
        else if (appVersion.match(/i(Phone|Pad|Pod)/)) result = 'iOS'
        else if (appVersion.indexOf('OS X') != -1) result = 'OS X'
        else if (appVersion.indexOf('Android') != -1) result = 'Android'
        else if (appVersion.indexOf('Linux') != -1) result = 'Linux'
        return result
    }

    var data = {
        type: 'user',
        latitude: lat,
        longitude: lng,
        os: getOSName(),
        browser: navigator.userAgent || navigator.appVersion,
        displayWidth: window.innerWidth,
        displayHeight: window.innerHeight,
    }

    //expose userdata globally to use current (cached)
    // location when calculating distances to providers
    window.userData = data

    if (window.myProfile) {
        data.email = window.myProfile.email
        data.userId = window.myProfile.id
    }

    if (window.use && use.env && use.env.DEV_ENV)
        data.background = true

    return window.postRequest('app/sendInfo', data).fail(function(err) {
        console.log('Sending info failed. ' + err.responseText)
    })
}

function addCodeAfterLogin(code) {
    console.log('Code', code, 'will be entered after login.')
    window.store.set('codeToSetAfterLogin', code)
    var expirationTime = new Date()
    expirationTime.setHours(expirationTime.getHours() + 2)
    window.store.set('codeToSetAfterLoginExpiration', expirationTime)
}

function handleDeepLinks(locationHash, isLoggedIn) {
    var PREDEFINED_CODE_REGEXP = /#codes\/([0-9a-zA-Z_-]+)/
    var PREDEFINED_OFFER_REGEXP = /#offer\/([0-9a-zA-Z_-]+)/
    var PREDEFINED_PROVIDER_REGEXP = /#provider\/([0-9a-zA-Z_-]+)/
    var match

    // log('!!! Handle deep links?', locationHash, isLoggedIn);

    if (locationHash === '#credits') {
        if (isLoggedIn) {
            wait.profile.then(function() {
                new window.CreditView().show()
            })
        }
    } else if (locationHash === '#gift') {
        if (isLoggedIn) {
            wait.profile.then(function() {
                new window.CreditView(null, { gift: 1 }).show()
            })
        }
    } else if (locationHash === '#codes') {
        if (isLoggedIn) {
            new window.SettingsCodeView().show()
        }
    } else {
        match = locationHash.match(PREDEFINED_CODE_REGEXP)

        if (match) {
            if (isLoggedIn) {
                new window.SettingsCodeView(null, { predefinedCode: match[1] }).show()
            } else {
                addCodeAfterLogin(match[1])
            }
        } else {
            match = locationHash.match(PREDEFINED_OFFER_REGEXP)

            if (match) {
                // If some request fails at some point, we just don't show the view in question.
                window.getRequest('app/offer/' + match[1]).then(function(offerData) {
                    var offer = JSON.parse(offerData)
                    window.getRequest('app/provider/' + offer.providerId).then(function(providerData) {
                        var provider = JSON.parse(providerData)
                        offer.provider = provider
                        window.goToLocation(offer.provider, 16)
                        var isOfferActive = offer.unitsLeft > 0 && offer.active
                        if (isOfferActive) {
                            new window.OfferDetailsView(null, offer).show()
                        } else {
                            new window.ProviderView(null, provider).show()
                        }
                    })
                })
            } else {
                match = locationHash.match(PREDEFINED_PROVIDER_REGEXP)

                if (match) {
                    // If some request fails at some point, we just don't show the view in question.
                    window.getRequest('app/provider/' + match[1]).then(function(providerData) {
                        var provider = JSON.parse(providerData)
                        window.goToLocation(provider, 16)
                        new window.ProviderView(null, provider).show()
                    })
                }
            }
        }
    }
}

function intercomInit(profile) {
    if (!use.env.ENABLE_INTERCOM_WEBAPP_CHAT) {
        console.log('Intercom chat disabled')
        return
    }

    if (!use.env.INTERCOM_APP_ID) {
        console.log('WARNING - Intercom provider chat enabled but INTERCOM_APP_ID is not specified')
        return
    }

    window.intercomSettings = {
        app_id: use.env.INTERCOM_APP_ID,
        user_id: profile.intercom.externalId,
        email: profile.email,
        user_hash: profile.intercom.hmacDigest,
        created_at: new Date(profile.registeredDate).getTime() / 1000 | 0,
        user_type: 'user',
        api_base: "https://api-iam.eu.intercom.io",
        horizontal_padding: 60,
        vertical_padding: 36

    }

    if (profile.fullName) {
        window.intercomSettings.name = profile.fullName
    }

    // Modified Intercom library
    (function() {
        var w = window
        var ic = w.Intercom
        if (typeof ic === 'function') {
            ic('reattach_activator')
            ic('update', window.intercomSettings)
        } else {
            var d = document
            var i = function() {
                i.c(arguments)
            }
            i.q = []
            i.c = function(args) {
                i.q.push(args)
            }
            w.Intercom = i
            const l = function() {
                var s = d.createElement('script')
                s.type = 'text/javascript'
                s.async = true
                s.src = `https://widget.intercom.io/widget/${use.env.INTERCOM_APP_ID}`
                var x = d.getElementsByTagName('script')[0]
                x.parentNode.insertBefore(s, x)
            }

            if (d.readyState === 'complete') { // this check added by ResQ
                l()
            } else if (w.attachEvent) {
                w.attachEvent('onload', l)
            } else {
                w.addEventListener('load', l, false)
            }
        }
    })()
}

function initTopBar() {
    const centerElement = $('<button class="topBar-centerElement"></button>')
        .text('')

    let profileLoaded = false

    wait.profile.then(profile => {
        profileLoaded = true
        if (profile.nonsurplusEnabled) {
            centerElement.text(lang.feed.nonsurplus.button.allOffers)
        } else {
            centerElement.text(lang.feed.nonsurplus.button.surplusOnly)
        }
    })

    centerElement.click(() => {
        if (!profileLoaded) {
            return
        }

        const nonsurplusEnabled = !use.profile.nonsurplusEnabled

        window.postRequest('app/setNonsurplusEnabled', { nonsurplusEnabled }).then(profile => {
            // This is a bit dirty. However, it's a straightforward way to get through to
            // backdoor that doesn't allow the global profile to change.
            use.profile.nonsurplusEnabled = profile.profile.nonsurplusEnabled

            // log('nonsurplusEnabled is now', use.profile.nonsurplusEnabled)

            if (use.profile.nonsurplusEnabled) {
                centerElement.text(lang.feed.nonsurplus.button.allOffers)
            } else {
                centerElement.text(lang.feed.nonsurplus.button.surplusOnly)
            }

            // offersUpdated listener internally relies on profile - this is just enough to
            // trigger the update
            window.eventManager.dispatch('offersUpdated')
        })
    })

    const isUserLoggedIn = Boolean(use.env.user)
    const topBar = window.createTopBar(null, {
        language: false,
        container: $('#main'),
        centerElement: isUserLoggedIn ? centerElement : null,
    })
        .append('<div id="backButton"></div>')
        .append($('<div id="frontButton" class="shareButton">'))

    const topBarLogo = topBar.__logoElement
    const centerElementWrapper = topBar.__centerElementWrapper

    topBarLogo && topBarLogo.addClass('hidden')
    centerElementWrapper && centerElementWrapper.addClass('hidden')

    wait.env.then(env => {
      topBarLogo && topBarLogo.removeClass('hidden')
    })

    topBar.append(window.createProfileButton())
    const searchButton = window.createSearchButton()
    topBar.append(searchButton)
    searchButton.hide()

    // Hack: make search button invisible and if after fetching profile
    // we find out that it shouldn't be enabled, delete it for good
    // Once search is implemented completely, just remove all code from below:
    searchButton.css('opacity', 0)

    wait.env.then(env => {
        if (env.DEV_ENV) {
            searchButton.show()
            searchButton.css('opacity', 1)
        } else {
            wait.profile.then(profile => {
                if (profile.codes.some(code => code.code.endsWith('TONNINSETELI'))) {
                    searchButton.show()
                    searchButton.css('opacity', 1)
                } else {
                    searchButton.remove()
                }
            })
        }
    })
}

function startRefreshInterval() {
    var animId = null
    setInterval(function() {
        if (animId && window.cancelAnimationFrame) {
            window.cancelAnimationFrame(animId)
            animId = null
        }
        if (window.refreshOffersPrevious + 5000 > Date.now()) {
            // don't do too often
            return
        }

        if (window.requestAnimationFrame) {
            animId = window.requestAnimationFrame(window.refreshOffers)
        } else {
            window.refreshOffers()
        }
    }, 60000)
}

; /* START FILE app/js/init.js */ // Store these - handleQueryParameters.js discards location.hash and query
// TODO check comment there and fix
window.initialLocationHash = location.hash
window.initialLocationHref = location.href

function initMainApp() {
	window.rootView = null

	window.updateTags()

	// Intercom chat widget
	wait.profile.then(function(profile) {
		window.intercomInit(profile)
	})

	if (window.isTouch) $('#main').addClass('touchScreen')

	window.initTopBar()

	$('#bigMapContainer').append(window.createGoToMyLocationButton())
	$('#smallMapContainer').append(window.createGoToMyLocationButton())

	window.rootView = new window.OffersView()
	window.rootView.show()

	window.startRefreshInterval()

	if (use.env.user) {
    // Identify user with Hotjar
    if (window.hj) {
      window.hj('identify', use.env.user.id, {});
    }

		// User is logged in
		window.login(function() {
			if (window.store.get('showFirstTimeInfo')) {
				window.store.remove('showFirstTimeInfo')
				window.openFirstTimePopup(window.goToMyLocation)
			} else {
				//goToMyLocation();
				window.updateMyLocation()
			}
		})

		window.handleDeepLinks(window.initialLocationHash, true)
	} else {
		// User is not logged in
		window.logout()
		window.updateMyLocation()

		window.handleDeepLinks(window.initialLocationHash, false)
	}

	window.removeHash()
}

function initChangePassword() {
	var str = '?token='
	var url = window.initialLocationHref
	var pos = url.indexOf(str)
	var changeUserPasswordToken = url.substring(pos+str.length)

	var placeholder = ''
	for (var i = 0; i < use.env.PASSWORD_MIN_LENGTH; i++) {
		placeholder += '*'
	}

	window.createTopBar(null, { language: false })
	var dlg = new window.ModalDialog(lang.changePassword.title, {
		submitFromEnter: true, horizontalLine: false, popup: false,
		autoTabIndexify: true, autofocusFirstInput: true
	})

	var new1 = dlg.addInputOld('newPassword', lang.changePassword.newPassword, placeholder, 'password', '')
	var new2 = dlg.addInputOld('newPassword2', lang.changePassword.newPassword2, placeholder, 'password', '')

	dlg.addButton(lang.changePassword.login, function(data) {

		if (new1() != new2()) {
			alert(lang.changePassword.notTwoTimesRight)
			dlg.enableAllAgain()
			return
		}

		data.changeUserPasswordToken = changeUserPasswordToken

		window.postRequest('app/changePasswordWithToken', data).done(function(results) {
			results = JSON.parse(results)

			var data2 = {
				email: results.email,
				password: data.newPassword
			}

			window
				.postRequest('app/login', data2)
				.done(function(results) {
					results = JSON.parse(results)
					window.store.set('userToken', results.userToken)
					window.redirect('./', 'replace')
				})
				.fail(window.dialogFailResponse)
		}).fail(window.dialogFailResponse)
	})


	var dialog = dlg.getDialogElement().appendTo($('body'))

	var input = dialog.find('input').first()

	if (input.val() == '') input.focus()
}
//# sourceMappingURL=bundle.js.map